/* NZS-SPD-0808 — assets/nzs-header-drawer.js
   EXTRACTED from the inline <script> at sections/nzs-header.liquid:1076-2031 (the "Cart drawer
   disclosures" block: disclosures, the cart drawer itself, reward ladder, recs + recently-viewed
   tabs, the mobile nav drawer and the More menu). 69,377 B of inline JS off every page's HTML.

   ONE Liquid interpolation existed in the block and is BRIDGED, not inlined — everything else is
   byte-for-byte the original. The change, and only this change:
     was:  '<img class="nzs-cdr__pt-img" src="{{ 'nzs-ladder-truck.png' | asset_img_url: '104x' }}" ...>'
     now:  built from TRUCK_SRC, read from data-nzs-truck-src on #nzsCartDrawer, which
           sections/nzs-header.liquid:184 renders with that same asset_img_url filter.
   (The other `{{`/`}}`-looking hits in the block — cart.js fetch options, CustomEvent detail
   objects, the /cart/change payload — are JS object literals, not Liquid.)

   DEFER TIMING — checked, not assumed:
   * Every element it touches (#nzsCartToggle:32, #nzsCartOverlay:183, #nzsCartDrawer:184,
     #nzsHdrSpacer:335, #nzsBurger/#nzsMnav/#nzsMore) is rendered ABOVE line 1076, so nothing
     depends on this running mid-parse.
   * :1972 `if(document.readyState==='loading') addEventListener('DOMContentLoaded',cartEnhance)
     else cartEnhance()`. Inline it took the 'loading' branch and enhanced at DOMContentLoaded,
     by which time the deferred nzs-overlay.js had already defined window.nzsOverlay. Deferred it
     takes the else branch and enhances immediately — still AFTER nzs-overlay.js (defer preserves
     document order) so window.nzsOverlay is defined either way. Same end state, marginally
     earlier. Ditto mEnhance at :2010.
   * :2023-2026 register fallback closers in window.__nzsSurfaces only `if(!cartOverlay)` /
     `if(!mOverlay)`; nzsOverlay.enhance() registers the real ones. Both orders converge.
   * No document.write, no synchronous layout read that another parse-time script consumes.
   KNOWN COST: the cart-icon click handler (:1954) now binds after the full HTML parse instead of
   mid-header. On a slow connection there is a slightly longer window where tapping the cart icon
   does nothing. That window shrinks as the collection pages get smaller, which is this batch's
   whole point, but it is the one real behavioural risk in this move — see reports/L.md.
*/
/* ===== Cart drawer disclosures ===== */
(function(){
  var drawer=document.getElementById('nzsCartDrawer'); if(!drawer) return;
  var buttons=[].slice.call(drawer.querySelectorAll('[data-cdr-disclosure]')), byName={};
  function name(btn){ return btn.getAttribute('data-cdr-disclosure'); }
  function key(btn){ return 'nzs-cdr-'+name(btn)+'-open'; }
  function setDisclosure(btn,open){
    var panel=document.getElementById(btn.getAttribute('aria-controls'));
    btn.setAttribute('aria-expanded',open?'true':'false');
    btn.parentNode.classList.toggle('is-expanded',open);
    if(panel){ panel.setAttribute('aria-hidden',open?'false':'true'); if(name(btn)==='recs') panel.hidden=!open; }
    /* NZS-CDR-PROMO-DISCLOSE-0922: keep the grid mounted, but closed controls unfocusable. */
    if(panel&&name(btn)==='promo'){
      panel.inert=!open;
      if(open){ var input=panel.querySelector('input'); if(input) input.focus({preventScroll:true}); }
      else if(panel.contains(document.activeElement)) btn.focus({preventScroll:true});
    }
  }
  function setOnly(btn,open){
    buttons.forEach(function(other){
      var on=open&&other===btn;
      setDisclosure(other,on);
      /* NZS-CDR-PROMO-DISCLOSE-0922: promo state never persists. */
      if(name(other)!=='promo') try{ sessionStorage.setItem(key(other),on?'1':'0'); }catch(e){}
    });
  }
  var restored=null;
  buttons.forEach(function(btn){ byName[name(btn)]=btn; /* NZS-CDR-PROMO-DISCLOSE-0922 */ if(name(btn)!=='promo'&&!restored){ try{ if(sessionStorage.getItem(key(btn))==='1') restored=btn; }catch(e){} } });
  /* NZS-CDR-PROMO-DISCLOSE-0922: reuse this engine for render/open resets. */
  drawer.addEventListener('nzs:cdr-promo-disclosure',function(e){ if(byName.promo) setDisclosure(byName.promo,!!e.detail); });
  setOnly(restored,!!restored);
  buttons.forEach(function(btn){
    btn.addEventListener('click',function(){ setOnly(btn,btn.getAttribute('aria-expanded')!=='true'); });
  });
  var pts=document.getElementById('nzsCdrRewardPts');
  if(pts&&byName.perks&&window.MutationObserver){
    new window.MutationObserver(function(){ if(byName.perks.getAttribute('aria-expanded')!=='true'&&pts.querySelector('.just-hit')) setOnly(byName.perks,true); }).observe(pts,{subtree:true,attributes:true,attributeFilter:['class']});
  }
})();

/* ===== Cart Drawer ===== */
(function(){
  var toggle = document.getElementById('nzsCartToggle');
  var overlay = document.getElementById('nzsCartOverlay');
  var drawer = document.getElementById('nzsCartDrawer');
  var closeBtn = document.getElementById('nzsCartClose');
  var itemsEl = document.getElementById('nzsCdrItems');
  var footEl = document.getElementById('nzsCdrFoot');
  var cntEl = document.getElementById('nzsCdrCount');
  var subtEl = document.getElementById('nzsCdrSubtotal');
  /* NZS-CDR-CO-PRICE-0924 (Blake): Checkout reads like the PDP Add to cart - "CHECKOUT - $was $now". Mirrors the
     subtotal + visible "Total saved" row from the DOM, so every existing paint path keeps it in sync. */
  function coPrice(){
    var el=document.getElementById('nzsCdrCoPrice'); if(!el||!subtEl) return;
    var num=function(t){ var n=parseFloat(String(t||'').replace(/[^0-9.]/g,'')); return isNaN(n)?0:n; };
    var now=num(subtEl.textContent), sv=document.getElementById('nzsCdrSavings'), amt=document.getElementById('nzsCdrSavingsAmt');
    var save=(sv&&sv.style.display!=='none'&&sv.style.visibility!=='hidden'&&amt)?num(amt.textContent):0;
    el.innerHTML=now?' \u2013 '+(save>=1?'<s>'+money(Math.round((now+save)*100))+'</s> ':'')+'<b>'+esc(subtEl.textContent)+'</b>':'';
  }
  var dotEl = document.getElementById('nzsCartDot');
  if(!toggle||!drawer) return;
  var cartRoot=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  /* NZS-SPD-0808: the one Liquid value this block used, bridged off the drawer element. */
  var TRUCK_SRC=(drawer&&drawer.getAttribute('data-nzs-truck-src'))||'';
  function money(c){ return '$'+(c/100).toFixed(2); }
  function esc(s){ return String(s==null?'':s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];}); }
  /* Reward ladder — amounts in cents. NZS-OFFERS-0820: tiers now come from the
     Liquid-rendered #nzsCdrOffersCfg JSON in nzs-header.liquid (single source of truth for
     thresholds AND the gift pool); this array is only the fallback if that JSON is absent. */
  var REWARDS=[{amt:7000,label:'Free shipping',icon:'truck'}];
  try{
    var _cfgEl=document.getElementById('nzsCdrOffersCfg');
    if(_cfgEl){ var _cfg=JSON.parse(_cfgEl.textContent||'{}'); if(_cfg&&_cfg.tiers&&_cfg.tiers.length){ REWARDS=_cfg.tiers; window.__nzsCdrCfg=_cfg; } }
  }catch(_e){}
  function rwIcon(name){
    if(name==='truck') return TRUCK_SRC ? '<img class="nzs-cdr__pt-img" src="'+TRUCK_SRC+'" alt="" loading="eager">' : ''; /* NZS-LADDER-TRUCK v2 (Blake 2026-07-31): custom shaker-truck mark, white-trimmed + transparent */
    if(name==='gift'){
      /* NZS-OFFERS-0820 r6: Blake's gift icon (Downloads) as a currentColor mask so it takes the
         reached/unreached state colours exactly like the old inline SVG did. */
      var _gs=(window.__nzsCdrCfg&&window.__nzsCdrCfg.gift)||'';
      if(_gs) return '<span class="nzs-cdr__gift-mask" style="-webkit-mask-image:url('+_gs+');mask-image:url('+_gs+')"></span>';
      return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"/><path d="M7.5 8a2.5 2.5 0 0 1 0-5C11 3 12 8 12 8s1-5 4.5-5a2.5 2.5 0 0 1 0 5"/></svg>';
    }
    if(name==='star') return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>';
    if(name==='percent') return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="19" y1="5" x2="5" y2="19"/><circle cx="6.5" cy="6.5" r="2.5"/><circle cx="17.5" cy="17.5" r="2.5"/></svg>';
    return '';
  }
  /* NZS-OFFERS-0820 r3: checkpoints are EVENLY spaced (proportional spacing crams $70/$155
     together at 4 tiers); the fill interpolates piecewise between checkpoint positions so it
     still reads as real progress. All thresholds/titles come from the config. */
  function ptPos(i){ return (i+1)/REWARDS.length*100; }
  function updateReward(cart){
    var wrap=document.getElementById('nzsCdrReward'); if(!wrap) return;
    if(!(cart===currentCart&&cart.items&&cart.items.length&&Object.keys(pending).length)) nudgeSync(cart); /* NZS-CDR-NUDGE-0923: same cart the reward message uses; with pending writes only the applyPending projection syncs (one pass) */
    if(!REWARDS.length||!cart.items||!cart.items.length){ wrap.style.display='none'; return; }
    wrap.style.display='';
    var sub=0; /* NZS-CDR-QUAL-0923: each tier is measured with its own total (free shipping vs gift tiers) */
    var next=null, prevAmt=0, prevPos=0, nextPos=100, pct=100;
    for(var i=0;i<REWARDS.length;i++){
      if(tierQual(cart,REWARDS[i])<REWARDS[i].amt){ next=REWARDS[i]; sub=tierQual(cart,next); nextPos=ptPos(i); prevPos=i>0?ptPos(i-1):0; prevAmt=i>0?REWARDS[i-1].amt:0; break; }
    }
    if(next){
      var frac=(sub-prevAmt)/(next.amt-prevAmt); if(!(frac>=0)) frac=0; if(frac>1) frac=1;
      pct=prevPos+frac*(nextPos-prevPos);
    }
    var fill=document.getElementById('nzsCdrRewardFill'); if(fill) fill.style.width=pct+'%';
    var msg=document.getElementById('nzsCdrRewardMsg');
    if(msg){
      if(nudgeFsTier()&&shipBlocked(cart)) msg.innerHTML=drinkMsg(); /* NZS-DRINKSHIP-1007: the bar still shows spend; the truck stays unreached */
      else if(next) msg.innerHTML=(next.opts&&next.opts.length)?'Spend <b>'+money(next.amt-sub)+'</b> more to unlock: <b>'+esc(next.label)+'</b>':'Spend <b>'+money(next.amt-sub)+'</b> more for '+esc(next.label.toLowerCase());
      else msg.innerHTML='You’ve unlocked '+(REWARDS.length>1?'all rewards':esc(REWARDS[REWARDS.length-1].label.toLowerCase()))+'! 🎉';
    }
    var pts=document.getElementById('nzsCdrRewardPts');
    if(pts){
      if(pts.children.length!==REWARDS.length){
        pts.innerHTML=REWARDS.map(function(r,i){
          var reached=tierOk(cart,r); /* NZS-CDR-QUAL-0923; NZS-DRINKSHIP-1007 */
          return '<div class="nzs-cdr__reward-pt'+(reached?' is-reached':'')+'" style="left:'+ptPos(i)+'%" title="'+esc(r.label)+' – '+money(r.amt)+'">'+rwIcon(r.icon)+'<span class="nzs-cdr__pt-lbl">'+moneyShort(r.amt)+'</span></div>';
        }).join('');
      } else {
        REWARDS.forEach(function(r,i){
          var el=pts.children[i]; if(!el) return;
          var reached=tierOk(cart,r), wasReached=el.classList.contains('is-reached'); /* NZS-CDR-QUAL-0923 */
          if(reached&&!wasReached&&!_replayPend[i]){ /* NZS-CDR-PRELOAD-1009: a replaying point re-lights on its own timer */
            el.classList.add('is-reached','just-hit');
            setTimeout(function(){ el.classList.remove('just-hit'); },500);
          } else if(!reached&&wasReached){
            el.classList.remove('is-reached');
          }
        });
      }
    }
    if(_replayDue&&drawer.classList.contains('is-entering')){ _replayDue=false; rewardReplay(); } /* NZS-CDR-PRELOAD-1009: bar was hidden at open (empty cart, first add) */
  }
  /* NZS-CDR-PRELOAD-1009 (Blake, Gymshark): every open grows the bar from 0 and re-lights reached points as the fill
     passes them. Snap to 0 while shut (forced reflow, never rAF), then #nzsCdrRewardFill.is-replay runs with the slide.
     A point re-lights only if the cart at that moment (projected while writes are pending) still reaches it. */
  var _replayT=[], _replayPend={}, _replayDue=false, _enterT=0;
  function replayCart(){ return currentCart&&Object.keys(pending).length?projectedCart(currentCart):currentCart; }
  function rewardReplay(){
    var wrap=document.getElementById('nzsCdrReward'), fill=document.getElementById('nzsCdrRewardFill'), pts=document.getElementById('nzsCdrRewardPts');
    _replayT.forEach(clearTimeout); _replayT=[];
    Object.keys(_replayPend).forEach(function(i){ var el=pts&&pts.children[i], c=replayCart(); if(el&&c&&tierOk(c,REWARDS[i])) el.classList.add('is-reached'); }); _replayPend={};
    if(!wrap||!fill||wrap.style.display==='none'){ _replayDue=true; return; }
    var w=fill.style.width, pct=parseFloat(w)||0; if(!pct){ _replayDue=true; return; }
    fill.classList.remove('is-replay'); fill.style.transition='none'; fill.style.width='0%'; void fill.offsetWidth;
    fill.style.transition=''; fill.classList.add('is-replay'); fill.style.width=w;
    _replayT.push(setTimeout(function(){ fill.classList.remove('is-replay'); },1100));
    if(pts) REWARDS.forEach(function(r,i){ var el=pts.children[i]; if(!el||!el.classList.contains('is-reached')) return;
      el.classList.remove('is-reached'); _replayPend[i]=1;
      _replayT.push(setTimeout(function(){ delete _replayPend[i]; var c=replayCart(); if(c&&tierOk(c,r)) el.classList.add('is-reached'); },120+Math.round(450*Math.min(1,ptPos(i)/pct))));
    });
  }
  function cdrEnter(){ /* rows/rail/nudge animate only inside this window, so later in-drawer renders never re-animate */
    clearTimeout(_enterT); drawer.classList.remove('is-entering'); _replayDue=false;
    if(cdrReduce.matches) return;
    void drawer.offsetWidth; drawer.classList.add('is-entering'); rewardReplay();
    _enterT=setTimeout(function(){ drawer.classList.remove('is-entering'); _replayDue=false; },1300);
  }
  function setBadge(n){
    if(dotEl){ dotEl.textContent=n; dotEl.style.display=n>0?'':'none'; }
    if(cntEl) cntEl.textContent=n;
  }
  /* NZS-CDR-NUDGE-0923 BEGIN: free-shipping nudge. When the NEXT tier is the no-gift (free shipping) tier and the
     reward-bar gap (next.amt - qualTotal) is small, name ONE "Customers Also Bought" card that closes it, with a
     one-tap Add. No new requests: candidates are the rail cards (#nzsCdrRecsRow), else the last rail seen this
     session (sessionStorage nzsCdrNudgeRail). Zero-shift rule (NZS-CDR-NOSHIFT-0922): the row only OPENS or CLOSES
     while the drawer is shut, in the first render of an open, or on a real cart change; rail arrivals and same-cart
     repaints may only swap content inside a row that is already shown (fixed height). */
  /* NZS-CDR-NUDGE-0923 v2 (owner): every reward tier, always the NEXT unreached one. Eligible only while
     tier*0.75 <= qualTotal < tier*0.90 (never right before the reward: they already know). A pick costs between
     the gap and gap + max($20, 15% of the tier). */
  var NUDGE_WIN_LO=0.75, NUDGE_WIN_HI=0.90, NUDGE_OVER_MIN=2000, NUDGE_OVER_PCT=0.15;
  var _nudgeFam={}; /* NZS-CDR-NUDGE-0923: product id -> variant-family tag, learned from rail cards (cart.js has no tags). */
  var _nudgeAdded={}; /* NZS-CDR-NUDGE-0923: pids added via the nudge this drawer-open session; never offered twice. */
  var _nudgeView={}; /* NZS-CDR-NUDGE-0923: the product page being viewed; never suggested (set by nudgeHarvest). */
  var _nudgeOut={}; /* NZS-CDR-NUDGE-0923: pids whose add came back sold out / unavailable this browser session (sessionStorage nzsCdrNudgeOut). */
  try{ JSON.parse(sessionStorage.getItem('nzsCdrNudgeOut')||'[]').forEach(function(p){ _nudgeOut[String(p)]=1; }); }catch(_){}
  /* NZS-CDR-NUDGE-0923 pure:start */
  function nudgeShort(t){ return String(t||'').split(/\s+[-\u2013\u2014|]\s+/)[0].trim(); } /* "Base - Size - Flavour" -> "Base" */
  function nudgeBase(t){ return nudgeShort(t).toLowerCase(); }
  /* NZS-CDR-NUDGE-0923 v3: no discount suppression. The qualifying totals are post-discount (NZS-CDR-QUAL-0923),
     so every nudge promise is computed on the money checkout sees. */
  /* Cart identity for "did the cart really change": qualifying total, discount and every line's key:qty. */
  function nudgeSig(cart){ return qualTotal(cart)+'/'+giftQual(cart)+'/d'+(shipBlocked(cart)?1:0)+'|'+(Number(cart&&cart.total_discount)||0)+'|'+((cart&&cart.items)||[]).map(function(it){ return it.key+':'+it.quantity; }).join(','); }
  function nudgeFsTier(){ for(var i=0;i<REWARDS.length;i++){ if(REWARDS[i].icon==='truck') return REWARDS[i]; } return null; } /* the configured free-shipping tier (cfg literal, truck icon) */
  function nudgeIsFs(t){ return !!t&&t.icon==='truck'; }
  function nudgeLabel(t){ return 'your '+String((t&&t.label)||'free gift').toLowerCase(); } /* "your premium free gift" */
  function nudgeNext(cart){ var bl=shipBlocked(cart); for(var i=0;i<REWARDS.length;i++){ if(bl&&nudgeIsFs(REWARDS[i])) continue; if(tierQual(cart,REWARDS[i])<REWARDS[i].amt) return REWARDS[i]; } return null; } /* v3: per-tier total; NZS-DRINKSHIP-1007: a blocked free-shipping tier is never targeted */
  function nudgeTierLive(t){ /* NZS-CDR-NUDGE-0923 v2: same availability rule as the Offers ladder (optAvail) */
    return nudgeIsFs(t)||(t.opts||[]).some(function(o){ return optAvail(o).length>0; });
  }
  /* NZS-CDR-NUDGE-0923 v2: products that ARE tier gifts (cfg items: variant id + product title) are never suggested. */
  var _nudgeGiftFor=null, _nudgeGiftSet=null;
  function nudgeGiftSet(){
    if(_nudgeGiftFor===REWARDS&&_nudgeGiftSet) return _nudgeGiftSet;
    var v={}, t={};
    REWARDS.forEach(function(r){ (r.opts||[]).forEach(function(o){ (o.items||[]).forEach(function(g){ if(g.vid) v[String(g.vid)]=1; if(g.t) t[String(g.t).trim().toLowerCase()]=1; }); }); });
    _nudgeGiftFor=REWARDS; _nudgeGiftSet={v:v,t:t}; return _nudgeGiftSet;
  }
  /* {tier, gap} when the cart sits in the next tier's window; paid lines, no real discount. Otherwise null. */
  function nudgeTarget(cart){
    var items=(cart&&cart.items)||[];
    if(!items.some(function(it){ var p=it.properties||{}; return !p._nzs_gift&&!p._Free; })) return null; /* empty or gift-only */
    var t=nudgeNext(cart); if(!t||!nudgeTierLive(t)) return null;
    var sub=tierQual(cart,t); /* v3 */
    if(!(sub>=Math.round(t.amt*NUDGE_WIN_LO)&&sub<Math.round(t.amt*NUDGE_WIN_HI))) return null;
    return {tier:t,gap:t.amt-sub};
  }
  function nudgeGap(cart){ var x=nudgeTarget(cart); return x?x.gap:0; }
  /* NZS-CDR-NUDGE-0923 v3: content for a SHOWN row when no product fits while the drawer is open (same height as a
     pick). Success = the highest tier now reached at or above the tier the row was targeting; otherwise neutral copy
     for the CURRENT next tier (each tier with its own total). A reached tier is never named in neutral copy. */
  function nudgeRest(cart,amt){
    var won=null, next=null, bl=shipBlocked(cart||{}), fs=nudgeFsTier();
    REWARDS.forEach(function(r){ if(bl&&nudgeIsFs(r)) return; /* NZS-DRINKSHIP-1007 */ if(tierQual(cart||{},r)>=r.amt){ if(amt!=null&&r.amt>=amt) won=r; } else if(!next) next=r; });
    if(won) return {kind:'win',tier:won};
    if(bl&&fs&&(!next||amt===fs.amt)) return {kind:'info',drinks:true,gap:0,tier:fs}; /* NZS-DRINKSHIP-1007: same box, honest copy */
    if(next) return {kind:'info',gap:next.amt-tierQual(cart||{},next),tier:next,bundle:!nudgeIsFs(next)&&nzsQual(cart||{}).bundle};
    return {kind:'win',tier:REWARDS[REWARDS.length-1]||{amt:7000,label:'Free shipping',icon:'truck'}}; /* every tier reached */
  }
  function nudgePick(cart,cards){
    var items=(cart&&cart.items)||[], tg=nudgeTarget(cart);
    if(!tg) return null;
    var gap=tg.gap, over=Math.max(NUDGE_OVER_MIN,Math.round(tg.tier.amt*NUDGE_OVER_PCT)), gx=nudgeGiftSet();
    var pids={}, fams={}, bases={};
    items.forEach(function(it){
      pids[String(it.product_id)]=1;
      if(_nudgeFam[it.product_id]) fams[_nudgeFam[it.product_id]]=1;
      var b=nudgeBase(it.product_title||it.title); if(b) bases[b]=1;
    });
    var best=null;
    (cards||[]).forEach(function(c){
      if(!(c.price>0)||c.price<gap||c.price>gap+over) return; /* samples/free items are price 0 */
      if(c.multi||!c.vid||/^gift-/.test(c.handle||'')) return; /* "Choose" cards need a picker, not one tap */
      if(gx.v[String(c.vid)]||gx.t[String(c.title||'').trim().toLowerCase()]) return; /* v2: a tier gift itself */
      if(pids[String(c.pid)]||_nudgeView[String(c.pid)]||_nudgeAdded[String(c.pid)]||_nudgeOut[String(c.pid)]||(c.fam&&fams[c.fam])||bases[nudgeBase(c.title)]) return; /* same product or family */
      if(!best||c.price<best.price) best=c; /* cheapest; ties keep candidate order */
    });
    return best?{card:best,gap:gap,tier:tg.tier}:null;
  }
  /* loadRecs' seed shape: top-value paid line + newest paid line (max 2). */
  function nudgeSeeds(cart){
    var paid=((cart&&cart.items)||[]).filter(function(it){ var p=it.properties||{}; return !p._nzs_gift&&!p._Free; });
    if(!paid.length) return [];
    var top=String(paid.slice().sort(function(a,b){ return (Number(b.original_line_price)||0)-(Number(a.original_line_price)||0); })[0].product_id), newest=String(paid[paid.length-1].product_id);
    return top===newest?[top]:[top,newest];
  }
  /* Prefetch decision: {seeds, target, key} or null (no request). The cart itself sits in nudge range, else on a PDP
     the cart plus this product would; and the cached candidates hold no fit for that target cart. key = seeds|target
     signature, for the negative cache. */
  function nudgePlan(cart,pdp,cache){
    cart=cart||{items:[]};
    var target=cart, seeds;
    if(nudgeGap(cart)) seeds=nudgeSeeds(cart);
    else {
      var items=cart.items||[];
      if(!pdp||!pdp.id||!(pdp.price>0)||items.some(function(it){ return String(it.product_id)===String(pdp.id); })) return null;
      target=Object.assign({},cart,{items:items.concat([{key:'nzs-pdp',product_id:pdp.id,product_title:pdp.title||'',quantity:1,original_line_price:pdp.price,final_line_price:pdp.price,properties:{}}])});
      if(!nudgeGap(target)) return null;
      seeds=[String(pdp.id)].concat(nudgeSeeds(cart)).slice(0,2);
    }
    if(!seeds.length||nudgePick(target,cache)) return null;
    return {seeds:seeds,target:target,key:seeds.join(',')+'|'+nudgeSig(target)};
  }
  /* NZS-CDR-NUDGE-0923 pure:end */
  /* NZS-CDR-NUDGE-0923 cache:start */
  /* Candidate cache v2: nzs-cdr-recs cards from the drawer rail, the PDP "Complete the Stack" host, the empty-cart
     best-seller HTML and the one idle prefetch. Deduped by pid (newest wins), capped, 1 h TTL per entry, sold-out pids
     dropped. A stale entry is harmless: picks are re-filtered against the live cart and the add goes through nzsATC. */
  var NUDGE_CACHE='nzsCdrNudgeRail', NUDGE_CACHE_TTL=3600000, NUDGE_CACHE_CAP=24;
  function nudgeCacheGet(){
    try{ var o=JSON.parse(sessionStorage.getItem(NUDGE_CACHE)||'null'), now=Date.now();
      if(o&&o.v===2&&Array.isArray(o.cards)) return o.cards.filter(function(c){ return c&&c.pid&&now-(c.t||0)<NUDGE_CACHE_TTL&&!_nudgeOut[String(c.pid)]; }); }catch(_){}
    return [];
  }
  function nudgeCacheMerge(cards){
    var now=Date.now(), best={}, order=[];
    (cards||[]).forEach(function(c){ nudgeFamLearn(c.pid,c.fam); });
    (cards||[]).map(function(c){ return Object.assign({t:now},c); }).concat(nudgeCacheGet()).forEach(function(c){ /* a card keeps its own observed-at t */
      var k=String(c.pid); if(!c.pid||_nudgeOut[k]||!(now-(c.t||0)<NUDGE_CACHE_TTL)) return;
      if(!best[k]){ best[k]=c; order.push(k); } else if((c.t||0)>(best[k].t||0)) best[k]=c; /* duplicate pid: the fresher observation wins */
    });
    var out=order.map(function(k){ return best[k]; }).sort(function(x,y){ return y.t-x.t; }); /* newest first; ties keep incoming order */
    try{ sessionStorage.setItem(NUDGE_CACHE,JSON.stringify({v:2,cards:out.slice(0,NUDGE_CACHE_CAP)})); }catch(_){}
  }
  function nudgeMarkOut(pid){ /* sold out: never offer again this session, and drop it from the cache */
    _nudgeOut[String(pid)]=1;
    try{ sessionStorage.setItem('nzsCdrNudgeOut',JSON.stringify(Object.keys(_nudgeOut))); sessionStorage.setItem(NUDGE_CACHE,JSON.stringify({v:2,cards:nudgeCacheGet()})); }catch(_){}
  }
  /* Negative cache: a prefetch plan (seeds|target signature) that produced no fit is not repeated for the TTL. */
  var NUDGE_NEG='nzsCdrNudgeNeg';
  function nudgeNegHas(key){ try{ var o=JSON.parse(sessionStorage.getItem(NUDGE_NEG)||'{}'); return !!o[key]&&Date.now()-o[key]<NUDGE_CACHE_TTL; }catch(_){ return false; } }
  function nudgeNegAdd(key){
    try{ var o=JSON.parse(sessionStorage.getItem(NUDGE_NEG)||'{}'), now=Date.now(), n={};
      Object.keys(o).forEach(function(k){ if(now-o[k]<NUDGE_CACHE_TTL) n[k]=o[k]; }); n[key]=now;
      sessionStorage.setItem(NUDGE_NEG,JSON.stringify(n)); }catch(_){}
  }
  /* pid -> variant-family map persisted for the session (24 h, 200 newest), so an in-cart sibling flavour stays
     excluded after navigating away from the page where its card was seen. */
  var NUDGE_FAM='nzsCdrNudgeFam', NUDGE_FAM_TTL=86400000, NUDGE_FAM_CAP=200;
  function nudgeFamLoad(){ try{ var o=JSON.parse(sessionStorage.getItem(NUDGE_FAM)||'{}'), now=Date.now(); Object.keys(o).forEach(function(k){ if(o[k]&&o[k].f&&now-o[k].t<NUDGE_FAM_TTL&&!_nudgeFam[k]) _nudgeFam[k]=o[k].f; }); }catch(_){} }
  function nudgeFamLearn(pid,fam){
    if(!pid||!fam||_nudgeFam[pid]===fam) return; _nudgeFam[pid]=fam;
    try{ var o=JSON.parse(sessionStorage.getItem(NUDGE_FAM)||'{}'), now=Date.now(), n={}; o[pid]={f:fam,t:now};
      Object.keys(o).filter(function(k){ return o[k]&&now-o[k].t<NUDGE_FAM_TTL; }).sort(function(a,b){ return o[b].t-o[a].t; }).slice(0,NUDGE_FAM_CAP).forEach(function(k){ n[k]=o[k]; });
      sessionStorage.setItem(NUDGE_FAM,JSON.stringify(n)); }catch(_){}
  }
  /* NZS-CDR-NUDGE-0923 cache:end */
  nudgeFamLoad();
  function nudgeParse(root){ /* nzs-cdr-rec-card.liquid cards under root (live DOM or a parsed section) */
    if(!root) return [];
    return Array.prototype.map.call(root.querySelectorAll('.nzs-cdr__rec[data-rec-pid]'),function(c){
      var btn=c.querySelector('[data-rec-add]'), img=c.querySelector('.nzs-cdr__rec-img img');
      return {pid:c.getAttribute('data-rec-pid'), vid:parseInt(c.getAttribute('data-rec-vid')||(btn&&btn.getAttribute('data-rec-add')),10)||0, price:Number(c.getAttribute('data-rec-price')), fam:c.getAttribute('data-rec-fam')||'',
        title:c.getAttribute('data-rec-title')||'', handle:c.getAttribute('data-rec-handle')||'', img:img?img.getAttribute('src'):'',
        multi:!btn||!!c.querySelector('script[data-nzs-qa-data],[data-nzs-qa-open]')};
    });
  }
  function nudgeLive(){ return nudgeParse(document.getElementById('nzsCdrRecsRow')); }
  /* Read-only harvest (no observers, no requests): PDP upsell host (hidden cards included) + empty-cart HTML.
     Runs at idle and in open(), so the first open of a session already has candidates at its first frame. */
  var _nudgeEmptySeen='';
  function nudgeHarvest(){
    var found=[], host=document.querySelector('[data-nzs-pdp-upsell]');
    if(host){
      var hp=host.getAttribute('data-product-id'), hf=host.getAttribute('data-product-family');
      nudgeFamLearn(hp,hf); /* the PDP product's family, for when it is in the cart */
      if(hp) _nudgeView[hp]=1;
      found=nudgeParse(host);
    }
    var pv=nudgePdp(); if(pv) _nudgeView[pv.id]=1;
    if(_emptyHtml&&_emptyHtml!==_nudgeEmptySeen){ _nudgeEmptySeen=_emptyHtml;
      var et=0; try{ et=Number(sessionStorage.getItem('nzsCdrEmptyT'))||0; }catch(_){}
      /* stamped with its fetch time (never "now"): a stale best-seller price can never beat a fresher rail/PDP card */
      if(Date.now()-et<NUDGE_CACHE_TTL) found=found.concat(nudgeParse(recsWrap(_emptyHtml)).map(function(c){ c.t=et; return c; }));
    }
    if(found.length) nudgeCacheMerge(found);
  }
  function nudgePdp(){ /* current PDP product + selected variant price (cents), from Shopify's analytics meta */
    try{
      var m=window.ShopifyAnalytics&&window.ShopifyAnalytics.meta, p=m&&m.product, v=null;
      if(!p||!p.id||!Array.isArray(p.variants)||!p.variants.length) return null;
      p.variants.forEach(function(x){ if(String(x.id)===String(m.selectedVariantId)) v=x; });
      v=v||p.variants[0];
      var price=Number(v.price); return price>0?{id:String(p.id),price:price,title:String(v.name||'')}:null;
    }catch(_){ return null; }
  }
  /* One idle decision per page view, at most ONE nzs-cdr-recs request. The cart is the drawer's (currentCart) or the
     existing page-load badge /cart.js (nudgePrefetchCart); no cart cookie = empty cart. */
  var _nudgePre={idle:false,cart:/(?:^|; )cart=/.test(document.cookie)?undefined:{items:[]},done:false};
  function nudgePrefetchCart(c){ if(_nudgePre.cart===undefined) _nudgePre.cart=c&&c.items?c:null; nudgePrefetchTry(); }
  function nudgePrefetchTry(){
    if(_nudgePre.done||!_nudgePre.idle) return;
    var cart=currentCart||_nudgePre.cart; if(cart===undefined) return; /* badge /cart.js not answered yet */
    _nudgePre.done=true;
    nudgeDecide(cart,0);
  }
  var NUDGE_HOST_WAIT=3000; /* PDP host checks at idle, +3 s, +6 s */
  function nudgeDecide(cart,n){
    if(!cart||navigator.webdriver||drawer.classList.contains('is-open')) return; /* open drawer: the rail fetches */
    var pdp=nudgePdp(), plan=nudgePlan(cart,pdp,nudgeCacheGet());
    if(!plan||nudgeNegHas(plan.key)) return;
    if(cart.items&&cart.items.length&&!(pdp&&plan.seeds.indexOf(String(pdp.id))>=0)) return; /* NZS-CDR-PRELOAD-1009: cart-seeded plans = the pre-rendered rail's one read; PDP-seeded ones still prefetch */
    var host=document.querySelector('[data-nzs-pdp-upsell]');
    if(host&&pdp&&plan.seeds.indexOf(String(pdp.id))>=0){
      /* "Complete the Stack" fetches this same section for this product: use its cards, never a duplicate request */
      if(host.getAttribute('aria-busy')!=='true'||host.querySelector('.nzs-cdr__rec[data-rec-pid]')){ nudgeHarvest(); return; }
      if(n<2){ setTimeout(function(){ nudgeDecide(currentCart||cart,n+1); },NUDGE_HOST_WAIT); return; }
      if(plan.seeds.length===1) return; /* seeds == [this product]: the host owns that exact URL; open() harvests its cards once rendered */
      /* host never rendered (not scrolled near) and the cart adds seeds: fall back to the one prefetch */
    }
    var ac=typeof AbortController==='function'?new AbortController():null, timer=setTimeout(function(){ if(ac) ac.abort(); },8000);
    var url=cartRoot+'search?section_id=nzs-cdr-recs&type=product&q='+encodeURIComponent(plan.seeds.map(function(i){ return 'id:'+i; }).join(' OR '));
    new Promise(function(res){ res(fetch(url,ac?{signal:ac.signal}:undefined)); }) /* a wrapped fetch may throw synchronously */
      .then(function(r){ if(!r.ok) throw 0; return r.text(); })
      .then(function(html){ nudgeCacheMerge(nudgeParse(recsWrap(html))); if(!nudgePick(plan.target,nudgeCacheGet())) nudgeNegAdd(plan.key); })
      .catch(function(){}).then(function(){ clearTimeout(timer); });
  }
  /* open(): runs while the drawer is still shut, so the first visible frame already shows the final row for the
     added cart (or the last known cart). The snap window stays open only when no cart is known yet. */
  function nudgeOpenSync(added){
    var c=added&&added.items?added:(_nudgeCart||(_nudgePre.cart&&_nudgePre.cart.items?_nudgePre.cart:null));
    _nudgeSnap=!c;
    if(c) nudgeSync(c);
  }
  (function(){
    function idle(){ _nudgePre.idle=true; nudgeHarvest(); nudgePrefetchTry(); }
    function sched(){ if(window.requestIdleCallback) window.requestIdleCallback(idle,{timeout:4000}); else setTimeout(idle,1500); }
    if(document.readyState==='complete') sched(); else window.addEventListener('load',sched,{once:true});
  })();
  var _nudgeCart=null, _nudgeSig='', _nudgeCur=null, _nudgeGap=0, _nudgeSnap=false, _nudgeSnapT=0, _nudgeSwapT=0, _nudgeSeen={}, _nudgeHtml='', _nudgeState='';
  var _nudgeSt=null; /* shown content: {kind:'pick',card,gap} | {kind:'win'} | {kind:'info',gap,amt}; null = hidden */
  var nudgeEl=null, nudgeIn=null, nudgeImg=null, nudgeIc=null, nudgeTxt=null, nudgeBtn=null;
  var NUDGE_RM=window.matchMedia?window.matchMedia('(prefers-reduced-motion: reduce)'):{matches:false};
  var NUDGE_TICK='<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>';
  function nudgeKey(st){ return st?(st.drinks?'drinks':st.kind==='pick'?'pick:'+st.card.pid+':'+st.tier.amt:st.kind+':'+st.tier.amt):''; }
  function nudgeFocusOut(){ if(nudgeEl.contains(document.activeElement)){ var co=document.getElementById('nzsCdrCheckout'), f=co&&!co.classList.contains('is-blocked')?co:closeBtn; if(f) f.focus(); } } /* keep focus in the drawer */
  function nudgeFill(st){
    var html, c=st.card;
    nudgeIn.classList.toggle('is-win',st.kind==='win'); nudgeIn.classList.toggle('is-info',st.kind==='info');
    if(st.kind==='pick'){
      if(c.img){ if(nudgeImg.getAttribute('src')!==c.img) nudgeImg.setAttribute('src',c.img); nudgeImg.hidden=false; } else nudgeImg.hidden=true;
      /* The gap lead-in hides on narrow drawers (the reward message above says it); the name ellipsizes alone so price + payoff stay visible. */
      /* v2: gift tiers never carry the lead-in (longer label; the reward message above states the gap) */
      html=(nudgeIsFs(st.tier)?'<span class="nzs-cdr__nudge-gap">You\u2019re <b>'+money(st.gap)+'</b> away. </span>':'')+'Add <b class="nzs-cdr__nudge-name">'+esc(nudgeShort(c.title)||c.title)+'</b> ('+money(c.price)+') and '+(nudgeIsFs(st.tier)?'shipping\u2019s free.':'unlock '+esc(nudgeLabel(st.tier))+'.');
      nudgeBtn.setAttribute('aria-label','Add '+c.title+' to cart');
      if(!_nudgeState) nudgeBtn.disabled=!!_nudgeOut[String(c.pid)]; /* v2: a new pick after a sold-out one is tappable again */
    } else if(st.kind==='win'){ nudgeIc.innerHTML=NUDGE_TICK; html='<b>'+(nudgeIsFs(st.tier)?'Free shipping':esc(st.tier.label))+' unlocked.</b>'; }
    else if(st.drinks){ nudgeIc.innerHTML=rwIcon('truck'); html=drinkMsg(); } /* NZS-DRINKSHIP-1007 */
    else if(nudgeIsFs(st.tier)){ nudgeIc.innerHTML=rwIcon('truck'); html='Add <b>'+money(st.gap)+'</b> more for free shipping.'; } /* v3: always the current next tier */
    else { nudgeIc.innerHTML=rwIcon(st.tier.icon||'gift'); html='Add <b>'+money(st.gap)+'</b> more to unlock '+esc(nudgeLabel(st.tier))+'.'+(st.bundle?'<span class="nzs-cdr__nudge-note"> Bundle deals don\u2019t count.</span>':''); } /* v3: suffix hidden on narrow drawers (CSS) */
    if(html!==_nudgeHtml){ _nudgeHtml=html; nudgeTxt.innerHTML=html; } /* compare our own string: innerHTML re-serialises &#39; / &quot; and would re-announce */
  }
  /* Set the content of the row. Never touches its height: pick / win / info share one fixed box. */
  function nudgeShow(st,instant){
    var prevKey=nudgeKey(_nudgeSt), key=nudgeKey(st);
    _nudgeSt=st; _nudgeCur=st.kind==='pick'?st.card:null; _nudgeGap=st.gap||0;
    if(st.kind!=='pick') nudgeFocusOut(); /* the button's box stays, but it is hidden */
    if(instant||!prevKey||key===prevKey){
      if(instant||!nudgeIn.classList.contains('is-swap')){ clearTimeout(_nudgeSwapT); nudgeIn.classList.remove('is-swap'); nudgeFill(st); }
      return; /* a pending crossfade fills the latest state when it lands */
    }
    nudgeIn.classList.add('is-swap'); clearTimeout(_nudgeSwapT); /* crossfade the content only */
    _nudgeSwapT=setTimeout(function(){ if(_nudgeSt) nudgeFill(_nudgeSt); nudgeIn.classList.remove('is-swap'); },140);
  }
  function nudgeSet(on){ /* visibility: only ever called while the drawer is shut or on the open's first frame, instantly */
    if(!on) nudgeFocusOut();
    nudgeEl.classList.add('is-snap');
    nudgeEl.classList.toggle('is-on',on);
    if(on){ nudgeEl.removeAttribute('aria-hidden'); nudgeEl.inert=false; } else { nudgeEl.setAttribute('aria-hidden','true'); nudgeEl.inert=true; }
    void nudgeEl.offsetHeight; nudgeEl.classList.remove('is-snap'); /* commit the end state without a transition */
  }
  /* cart given = render/projection path; no argument = the rail just rendered (or a sold-out swap). */
  function nudgeSync(cart){
    var changed=false;
    if(cart!==undefined){ var sig=nudgeSig(cart); changed=sig!==_nudgeSig; _nudgeSig=sig; _nudgeCart=cart; }
    if(!nudgeEl) return;
    var isOpen=drawer.classList.contains('is-open');
    var free=!isOpen||(_nudgeSnap&&cart!==undefined); /* drawer shut, or the first CART render of an open (a rail-only call never uses the snap window) */
    if(_nudgeSnap&&cart!==undefined&&!_nudgeSnapT) _nudgeSnapT=setTimeout(function(){ _nudgeSnap=false; _nudgeSnapT=0; },0);
    if(_nudgeState==='added'&&(free||changed)){ _nudgeState=''; nudgeBtn.disabled=false; } /* the add's cart has rendered */
    var live=nudgeLive(); if(cart===undefined&&live.length) nudgeCacheMerge(live);
    var cards=live.length?live:nudgeCacheGet();
    cards.forEach(function(c){ nudgeFamLearn(c.pid,c.fam); });
    var pick=_nudgeCart?nudgePick(_nudgeCart,cards):null, shown=nudgeEl.classList.contains('is-on');
    var st=pick?{kind:'pick',card:pick.card,gap:pick.gap,tier:pick.tier}:null; /* the ONLY state that may appear at open / while shut */
    if(free){ /* the only moments the row may appear or disappear, always instantly */
      if(st){ nudgeShow(st,true); if(!shown) nudgeSet(true); }
      else if(shown){ nudgeSet(false); _nudgeSt=null; _nudgeCur=null; }
    } else {
      /* open: the row's height NEVER changes (a qty tap must not move lines under the finger). A hidden row stays
         hidden until the next open; a shown row only swaps content: product, success, or neutral. */
      if(!shown) return;
      if(st) nudgeShow(st,NUDGE_RM.matches);
      else if(changed) nudgeShow(nudgeRest(_nudgeCart,_nudgeSt&&_nudgeSt.tier&&_nudgeSt.tier.amt),NUDGE_RM.matches); /* about the tier the row was targeting */
      /* rail arrival or same-cart repaint with no fit: keep the current content */
    }
    if(isOpen&&_nudgeCur&&nudgeEl.classList.contains('is-on')&&!_nudgeSeen[_nudgeCur.pid]){ _nudgeSeen[_nudgeCur.pid]=1; croEv('reward_nudge_shown',{pid:_nudgeCur.pid,gap:_nudgeGap,price:_nudgeCur.price,tier:_nudgeSt.tier.amt}); }
  }
  /* Same contract as the rail's [data-rec-add] delegate (bound to #nzsCdrRecsRow, so it cannot see this row):
     nzsATC.add, shared __nzsLoadOn/Off with its 1 s grace, disabled in flight, label swap on failure. After a
     confirmed add the button stays disabled until the add's cart renders (a queued render cannot allow a second tap). */
  function nudgeAdd(){
    var c=_nudgeCur; if(!c||nudgeBtn.disabled||_nudgeState) return;
    var gap=_nudgeGap, tierAmt=_nudgeSt.tier.amt, label=nudgeBtn.querySelector('.nzs-speed-label');
    var tapSig=_nudgeSig; /* nzsATC emits success (drawer render) BEFORE the promise settles */
    _nudgeState='inflight'; nudgeBtn.classList.remove('is-err');
    nudgeBtn.disabled=true; if(window.__nzsLoadOn) window.__nzsLoadOn(nudgeBtn);
    var add=window.nzsATC ? window.nzsATC.add({items:[{id:c.vid,quantity:1}]},{handle:c.handle}) : Promise.reject(new Error('Please try again'));
    add.then(function(){ _nudgeAdded[String(c.pid)]=1;
      /* The add's own cart already rendered (signature moved): nothing left to guard. Otherwise that render is still
         queued (behind _chainInFlight, or the null-cart refetch): hold the button until it lands. */
      if(_nudgeSig!==tapSig){ _nudgeState=''; nudgeBtn.disabled=false; } else _nudgeState='added';
      croEv('reward_nudge_add',{pid:c.pid,gap:gap,price:c.price,tier:tierAmt}); if(window.__nzsLoadOff) window.__nzsLoadOff(nudgeBtn); recsKey=''; /* confirmed-add hook renders the cart; the nudge closes itself */ })
      .catch(function(err){ var message=(err&&err.message)||"Couldn't add to cart", gone=!!err&&(err.code==='UNAVAILABLE'||err.status===422||/sold out|unavailable/i.test(message)); if(gone) nudgeMarkOut(c.pid); _nudgeState='err'; if(window.__nzsLoadOff) window.__nzsLoadOff(nudgeBtn); if(label) label.textContent=message; nudgeBtn.title=message; nudgeBtn.classList.add('is-err'); setTimeout(function(){ if(label) label.textContent='Add'; nudgeBtn.removeAttribute('title'); nudgeBtn.classList.remove('is-err'); _nudgeState='';
        if(gone) nudgeSync(); /* shown row: swap to another fit (content only); none fits: it closes on the next cart change */
        nudgeBtn.disabled=!!(_nudgeCur&&_nudgeOut[String(_nudgeCur.pid)]); },2500); });
  }
  (function nudgeMount(){
    var wrap=document.getElementById('nzsCdrReward'); if(!wrap) return;
    nudgeEl=document.createElement('div'); nudgeEl.className='nzs-cdr__nudge'; nudgeEl.id='nzsCdrNudge';
    nudgeEl.innerHTML='<div class="nzs-cdr__nudge-clip"><div class="nzs-cdr__nudge-in"><span class="nzs-cdr__nudge-thumb"><img class="nzs-cdr__nudge-img" alt="" width="40" height="40" decoding="async" hidden><span class="nzs-cdr__nudge-ic" aria-hidden="true"></span></span><p class="nzs-cdr__nudge-txt" aria-live="polite"></p><button class="nzs-cdr__nudge-add" type="button"><span class="nzs-speed-label">Add</span></button></div></div>';
    nudgeEl.setAttribute('aria-hidden','true'); nudgeEl.inert=true;
    wrap.appendChild(nudgeEl); /* below the bar: the message and its bar stay one unit and never move */
    nudgeIn=nudgeEl.querySelector('.nzs-cdr__nudge-in'); nudgeImg=nudgeEl.querySelector('img'); nudgeIc=nudgeEl.querySelector('.nzs-cdr__nudge-ic'); nudgeTxt=nudgeEl.querySelector('p'); nudgeBtn=nudgeEl.querySelector('button');
    nudgeBtn.addEventListener('click',nudgeAdd);
  })();
  /* NZS-CDR-NUDGE-0923 END */
  /* NZS-ROUND4-E-RTD-JS: obsolete drawer promo loader and renderer removed. */
  /* NZS-UPSELL-0911: Section Rendering recommendations keyed on the top-value anchor plus the newest paid line.
     ponytail: fetch curated cards in one section instead of complementary and related API passes. */
  /* NZS-UPSELL-0911: ponytail: edit the existing hook instead of a second implementation. */
  var recsKey='', recsSeq=0, recsAbort=null, recsFailUntil=0;
  var recsHead=document.querySelector('#nzsCdrRecs .nzs-cdr__recs-head');
  var recsHeading=recsHead?recsHead.textContent:'Customers Also Bought';
  /* NZS-CDR-NOSHIFT-0922 R1: same card parts and dimensions as the existing vertical rail. */
  function recsSkeleton(){
    return '<div class="nzs-cdr__rec nzs-cdr__rec-placeholder" aria-hidden="true"><span class="nzs-cdr__rec-img"></span><div class="nzs-cdr__rec-body"><span class="nzs-cdr__rec-title"></span><span class="nzs-cdr__rec-tick"></span><span class="nzs-cdr__rec-stars"></span><span class="nzs-cdr__rec-price"></span></div><span class="nzs-cdr__rec-add"></span></div>'.repeat(3);
  }
  function loadRecs(cart){
    var box=document.getElementById('nzsCdrRecs'), rowEl=document.getElementById('nzsCdrRecsRow');
    if(!box||!rowEl) return;
    var items=cart.items||[];
    if(!items.length){ ++recsSeq; if(recsAbort){ try{ recsAbort.abort(); }catch(_){} } box.style.display='none'; box.removeAttribute('data-done'); recsKey=''; return; } /* NZS-UPSELL-0911: ponytail: edit the existing hook instead of a second implementation. */
    /* NZS-UPSELL-0911: ponytail: one Liquid fetch instead of two recommendation API passes. */
    var inCart={}; items.forEach(function(it){ inCart[it.product_id]=1; });
    var paid=items.filter(function(it){ return !(it.properties||{})._nzs_gift; });
    if(!paid.length) paid=items;
    var byProd={}; paid.forEach(function(it){ var p=it.product_id, lp=it.final_line_price||it.price||0; if(byProd[p]==null||lp>byProd[p]) byProd[p]=lp; });
    /* NZS-UPSELL-0911: ponytail: read the top anchor directly instead of copying two sorted ids. */
    var anchors=Object.keys(byProd).sort(function(a,b){return byProd[b]-byProd[a];});
    var seeds=[Number(anchors[0])], newest=paid[paid.length-1].product_id;
    if(Number(newest)!==seeds[0]) seeds.push(Number(newest));
    var key=seeds.slice().sort().join(',');
    var seq=++recsSeq;
    if(recsAbort){ try{ recsAbort.abort(); }catch(_){} }
    rowEl.querySelectorAll('[data-rec-pid]').forEach(function(c){ if(inCart[c.getAttribute('data-rec-pid')]) c.remove(); });
    box.style.display=''; /* NZS-CDR-NOSHIFT-0922: three live-sized placeholders reserve the rail. */
    if(!rowEl.children.length) rowEl.innerHTML=recsSkeleton();
    if(key===recsKey && box.getAttribute('data-done')==='1') return;
    if(recsFailUntil && Date.now()<recsFailUntil) return;
    recsAbort=(typeof AbortController==='function')?new AbortController():null;
    var url=(window.Shopify&&Shopify.routes&&Shopify.routes.root?Shopify.routes.root:'/')+'search?section_id=nzs-cdr-recs&type=product&q='+encodeURIComponent(seeds.map(function(i){return 'id:'+i;}).join(' OR '));
    var _rc=null; try{ _rc=JSON.parse(sessionStorage.getItem('nzsCdrRecs')||'null'); }catch(_){} /* NZS-CDR-PRELOAD-1009: ponytail: last key only, 1 h like nzsCdrNudgeRail */
    (_rc&&_rc.k===key&&Date.now()-_rc.t<3600000?Promise.resolve(_rc.h):fetch(url,recsAbort?{signal:recsAbort.signal}:undefined)
      .then(function(r){ if(!r.ok) throw 0; return r.text(); })
      .then(function(h){ if(h.indexOf('data-cdr-recs-mode')>-1){ try{ sessionStorage.setItem('nzsCdrRecs',JSON.stringify({k:key,h:h,t:Date.now()})); }catch(_){} } return h; }))
      .then(function(html){
        if(seq!==recsSeq) return;
        var wrap=recsWrap(html); /* NZS-CDR-EMPTY-0922: shared section parser. */
        if(!wrap){ recsFailUntil=Date.now()+60000; return; }
        var kept=Array.prototype.filter.call(wrap.children,function(c){ return c.classList.contains('nzs-cdr__rec')&&!inCart[c.getAttribute('data-rec-pid')]; }).slice(0,8);
        rowEl.innerHTML='';
        kept.forEach(function(c){ rowEl.appendChild(c); });
        if(!kept.length) rowEl.innerHTML=recsSkeleton(); /* NZS-CDR-NOSHIFT-0922: empty results keep the block. */
        box.style.display=''; /* NZS-CDR-NOSHIFT-0922: empty results retain rail geometry. */ box.setAttribute('data-done','1'); recsKey=key; recsFailUntil=0;
        nudgeSync(); /* NZS-CDR-NUDGE-0923: rail cards changed, re-pick against the last reward cart */ /* NZS-SPD-0927-SM-D6: the rail refresh moved below */
        var head=box.querySelector('.nzs-cdr__recs-head');
        if(head) head.textContent=wrap.getAttribute('data-cdr-recs-mode')==='fallback'?'Popular right now':recsHeading;
        /* NZS-SPD-0927-SM-D6: the rail refresh (drag-scroll renderRail forces a layout) and the stars pass run one task after
           the swap, off the frame that paints the cards. Same calls, same order between them. */
        setTimeout(function(){
          if(window.nzsRefreshRails)window.nzsRefreshRails(box);
          rowEl.querySelectorAll('.nzs-cdr__rec[data-rec-pid]').forEach(function(c){
            var slot=c.querySelector('.nzs-cdr__rec-stars'); if(!slot) return;
            jmGet(c.getAttribute('data-rec-pid')).then(function(e){ var h=jmHtml(e); if(h) slot.innerHTML=h; });
          });
        },0);
        if(drawer.classList.contains('is-open')) croEv('rec_impression',{surface:'cdr',n:kept.length,pids:kept.map(function(c){ return c.getAttribute('data-rec-pid'); }),mode:wrap.getAttribute('data-cdr-recs-mode')});
      })
      .catch(function(err){
        if(seq!==recsSeq || (err&&err.name==='AbortError')) return;
        recsFailUntil=Date.now()+60000;
      });
  }
  /* NZS-CDR-EMPTY-0922: reuse the fallback section and its card data, once per session. */
  function recsWrap(html){ return new DOMParser().parseFromString(html,'text/html').querySelector('[data-cdr-recs-mode]'); }
  var _emptyHtml='', _emptyRequest=null;
  try{ _emptyHtml=sessionStorage.getItem('nzsCdrEmpty')||''; }catch(_){}
  function emptyCards(html){
    var wrap=recsWrap(html); if(!wrap||wrap.getAttribute('data-cdr-recs-mode')!=='fallback') return '';
    return Array.prototype.filter.call(wrap.children,function(c){ return c.classList.contains('nzs-cdr__rec'); }).slice(0,4).map(function(c){
      var a=c.querySelector('a[href]'), img=c.querySelector('img'), title=c.getAttribute('data-rec-title')||'';
      if(!a) return '';
      /* NZS-CDR-EMPTY-CTA-0922: separate navigation and purchase targets. */
      var options=c.querySelector('script[data-nzs-qa-data]'), vid=c.getAttribute('data-rec-vid'), handle=c.getAttribute('data-rec-handle')||'';
      var action=options?'data-nzs-qa-open aria-haspopup="dialog"':'data-nzs-empty-add="'+esc(vid||'')+'"';
      var button=vid?'<button type="button" class="nzs-cdr__bs-add" '+action+' data-vid="'+esc(vid)+'" data-handle="'+esc(handle)+'" aria-label="Add '+esc(title)+' to cart"><span class="nzs-speed-label">Add to cart</span></button>':'';
      return '<div class="nzs-cdr__bs-card'+(options?' nzs-bs__card':'')+'"><div class="nzs-cdr__bs-media"><a class="nzs-cdr__bs-image" href="'+esc(a.getAttribute('href'))+'" aria-label="'+esc(title)+'">'+(img?'<img src="'+esc(img.getAttribute('src'))+'" alt="" width="160" height="160">':'')+'<span class="nzs-cdr__bs-arrow" aria-hidden="true">↗</span></a>'+button+'</div><a class="nzs-cdr__bs-title" href="'+esc(a.getAttribute('href'))+'">'+esc(title)+'</a><span class="nzs-cdr__bs-price">'+money(Number(c.getAttribute('data-rec-price'))||0)+'</span><span class="nzs-cdr__bs-error" role="status"></span>'+(options?options.outerHTML:'')+'</div>';
    }).join('');
  }
  function paintEmpty(){
    var cards=_emptyHtml?emptyCards(_emptyHtml):'';
    itemsEl.innerHTML='<div class="nzs-cdr__empty-shop"><p>Your cart is empty</p><h2>Start with our best sellers</h2><div class="nzs-cdr__bs">'+(cards||'<span class="nzs-cdr__bs-placeholder" aria-hidden="true"></span>'.repeat(4))+'</div><div class="nzs-cdr__empty-trust"><span>'+rwIcon('truck')+'Free shipping over $70</span><span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M12 3l7 3v5c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6z"/><path d="m9 12 2 2 4-4"/></svg>30-day satisfaction guarantee</span></div></div>';
    if(cards||_emptyRequest) return;
    _emptyRequest=fetch(cartRoot+'search?section_id=nzs-cdr-recs&type=product&q=id:0').then(function(r){ if(!r.ok) throw 0; return r.text(); }).then(function(html){
      if(!emptyCards(html)) throw 0;
      _emptyHtml=html; try{ sessionStorage.setItem('nzsCdrEmpty',html); sessionStorage.setItem('nzsCdrEmptyT',String(Date.now())); /* NZS-CDR-NUDGE-0923: fetch time for the nudge cache */ }catch(_){}
      if(currentCart&&!currentCart.items.length){ var grid=itemsEl.querySelector('.nzs-cdr__bs'); if(grid) grid.innerHTML=emptyCards(html); }
    }).catch(function(){ /* Keep stable placeholders; retry on the next open. */ }).finally(function(){ _emptyRequest=null; });
  }
  itemsEl.addEventListener('click',function(e){
    /* NZS-CDR-EMPTY-CTA-0922: one unit, no inherited subscription or extra cart read. */
    var btn=e.target.closest('[data-nzs-empty-add]');
    if(btn){
      if(btn.disabled) return;
      var vid=Number(btn.getAttribute('data-nzs-empty-add')); if(!vid) return;
      var error=btn.closest('.nzs-cdr__bs-card').querySelector('.nzs-cdr__bs-error');
      error.textContent=''; btn.disabled=true;
      if(window.__nzsLoadOn) window.__nzsLoadOn(btn);
      var add=window.nzsATC?window.nzsATC.add({items:[{id:vid,quantity:1}]},{handle:btn.getAttribute('data-handle')}):Promise.reject(new Error('Please try again'));
      add.catch(function(err){error.textContent=err.message||"Couldn't add to cart. Please try again.";}).finally(function(){if(window.__nzsLoadOff) window.__nzsLoadOff(btn);btn.disabled=false;});
      return;
    }
    var a=e.target.closest('.nzs-cdr__bs-card a[href]');
    if(!a||e.defaultPrevented||e.button!==0||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey) return;
    e.preventDefault(); close(); if(window.__nzsNavSkTo) window.__nzsNavSkTo(a.href); else location.assign(a.href);
  });
  /* ===== NZS-CDR-RRP: cart.js has no compare_at_price, so enrich per-handle from /products/{handle}.js
     (memoised, same pattern as the RTD + recommendations fetches below). Map variant_id -> RRP cents. */
  /* NZS-CDR-NOSHIFT-0922: product-id memo, with one bounded section gate per open. */
  var _rrp={}, _rrpReq={}, _rrpFailed={}, _plans={}, _lastCart=null, _rrpFrame=0, _patchEnrichment=null;
  var _linesMemo={}, _openLines=null, _priceReserved={}, _subReserved={}, _savingsHeld=false;
  var _linesPending={}; /* NZS-CDR-NOSHIFT-0922 R5: counts retain coverage across overlapping opens. */
  try{ _linesMemo=JSON.parse(sessionStorage.getItem('nzsCdrLines')||'{}')||{}; }catch(_){}
  function linesEntry(pid){ var e=_linesMemo[pid]; return e&&Array.isArray(e.variants)&&Array.isArray(e.plans)&&typeof e.drinks==='number'&&Date.now()-e.t<86400000?e:null; } /* NZS-DRINKSHIP-1007: pre-1007 memos (no drinks) refetch once */
  function useLines(cart){
    (cart.items||[]).forEach(function(it){ var e=linesEntry(it.product_id); if(!e) return;
      e.variants.forEach(function(v){ _rrp[v.id]=Number(v.compare_at_price)||0; });
      if(it.handle) _plans[it.handle]=[{selling_plans:e.plans}];
    });
  }
  function linesKnown(it){ return (!_linesMemo[it.product_id]||!!linesEntry(it.product_id))&&_rrp[it.variant_id]!==undefined&&(!it.handle||_plans[it.handle]!==undefined); }
  function patchEnrichment(){
    if(!_rrpFrame) _rrpFrame=requestAnimationFrame(function(){ _rrpFrame=0; if(_patchEnrichment) _patchEnrichment(); drinkResync(); /* NZS-DRINKSHIP-1007 */ });
  }
  function beginLines(cart){
    if(cart){ useLines(cart); if((cart.items||[]).every(linesKnown)) return Promise.resolve(); }
    var ids=[]; ((cart&&cart.items)||[]).forEach(function(it){ if(ids.indexOf(it.product_id)<0) ids.push(it.product_id); });
    var query=ids.length?ids.map(function(id){return 'id:'+id;}).join(' OR '):'id:0';
    if(encodeURIComponent(query).length>1500) return Promise.resolve();
    /* NZS-CDR-NOSHIFT-0922 R5: id:0 covers the server cart before its product IDs are known. */
    var coverage=ids.length?ids:['*'];
    coverage.forEach(function(id){_linesPending[id]=(_linesPending[id]||0)+1;});
    var request=new Promise(function(res){ res(fetch(cartRoot+'search?section_id=nzs-cdr-lines&type=product&q='+encodeURIComponent(query))); }) /* NZS-CDR-NOSHIFT-0922 R5: a synchronous fetch throw (wrapped fetch) must still settle and release coverage. */
      .then(function(r){ if(!r.ok) throw 0; return r.text(); }).then(function(html){
        var node=new DOMParser().parseFromString(html,'text/html').querySelector('[data-cdr-lines]');
        var entries=node&&JSON.parse(node.textContent); if(!Array.isArray(entries)) throw 0;
        entries.forEach(function(e){ if(e&&e.product_id&&Array.isArray(e.variants)&&Array.isArray(e.plans)) _linesMemo[e.product_id]={variants:e.variants,plans:e.plans,drinks:Number(e.drinks)||0,t:Date.now()}; }); /* NZS-DRINKSHIP-1007 */
        try{ sessionStorage.setItem('nzsCdrLines',JSON.stringify(_linesMemo)); }catch(_){}
        if(_lastCart){ useLines(_lastCart); patchEnrichment(); }
      }).catch(function(){ /* Per-handle fallback owns failure and missing search results. */ })
      .then(function(){ /* NZS-CDR-NOSHIFT-0922 R5: only uncovered products fall back after settlement. */
        coverage.forEach(function(id){if(--_linesPending[id]===0) delete _linesPending[id];});
        if(_lastCart) loadRrp(_lastCart);
      });
    var timer;
    return Promise.race([request,new Promise(function(resolve){ timer=setTimeout(resolve,350); })]).then(function(){ clearTimeout(timer); });
  }
  function paintOpenCart(cart,seq){
    useLines(cart); var gate=(cart.items||[]).every(linesKnown)?null:_openLines; _openLines=null;
    return Promise.resolve(gate).then(function(){ if(seq!==_cartSeq) return; useLines(cart); _cartReady=true; render(cart); });
  }
  /* NZS-CDR-PRELOAD-1009 (Blake, Gymshark): build the shut drawer from the page-load cart at idle, so the first open
     paints products with no request. Same bounded lines gate as an open; an open in the meantime wins via _cartSeq. */
  function cdrPreRender(c){
    if(!c||!c.items||!c.token||!c.item_count) return;
    var s0=_cartSeq; /* an add/fetch started after the page-load read wins */
    function go(){ if(_cartReady||_cartSeq!==s0||drawer.classList.contains('is-open')) return; var seq=++_cartSeq; _openLines=beginLines(c); paintOpenCart(c,seq); }
    if(window.requestIdleCallback) window.requestIdleCallback(go,{timeout:2000}); else setTimeout(go,300);
  }
  function rrpFor(it){ var c=_rrp[it.variant_id]; return (c && c>it.price) ? c : 0; }
  function loadRrp(cart){
    var need=[];
    (cart.items||[]).forEach(function(it){
      if(!it.handle) _rrpFailed[it.product_id]=true;
      if(!it.handle||_rrpReq[it.handle]||linesKnown(it)||_linesPending['*']||_linesPending[it.product_id]) return; /* NZS-CDR-NOSHIFT-0922 R5 */
      if(need.indexOf(it.handle)<0) need.push(it.handle);
    });
    need.forEach(function(h){
      _rrpReq[h]=1;
      fetch('/products/'+h+'.js').then(function(r){ if(!r.ok) throw 0; return r.json(); }).then(function(p){
        if(!p||!Array.isArray(p.variants)) throw 0;
        p.variants.forEach(function(v){ _rrp[v.id]=v.compare_at_price||0; });
        _plans[h]=p.selling_plan_groups||[]; delete _rrpFailed[h];
        var plans=[]; _plans[h].forEach(function(g){ plans=plans.concat(g.selling_plans||[]); });
        if(p.id){ _linesMemo[p.id]={variants:p.variants.map(function(v){return {id:v.id,compare_at_price:v.compare_at_price||0};}),plans:plans,drinks:drinkGuess(p),t:Date.now()}; try{ sessionStorage.setItem('nzsCdrLines',JSON.stringify(_linesMemo)); }catch(_){} }
        patchEnrichment();
      }).catch(function(){ delete _rrpReq[h]; _rrpFailed[h]=true; patchEnrichment(); /* Keep reserved geometry, reveal the confirmed cart price. */ });
    });
  }
  function savingsPaint(amount,unknown){
    var el=document.getElementById('nzsCdrSavings'), value=document.getElementById('nzsCdrSavingsAmt');
    _savingsHeld=_savingsHeld||unknown;
    if(el){ el.style.display=amount>=100||_savingsHeld?'':'none'; el.style.visibility=unknown||amount<100?'hidden':''; /* NZS-CDR-FINISH-0923: under $1 = no row */ }
    if(value) value.textContent='-'+money(amount);
    coPrice(); /* NZS-CDR-CO-PRICE-0924 */
  }
  function subAction(it,gift){
    if(gift) return '';
    var key=esc(it.key);
    if(it.selling_plan_allocation) return '<button class="nzs-cdr__subundo" type="button" data-subup-undo="'+key+'"><span class="nzs-speed-label">Switch to one-time</span></button>';
    return subPlans(it.handle).length?'<button class="nzs-cdr__subup" type="button" data-subup="'+key+'" aria-expanded="false">Subscribe &amp; save 10%</button>':'';
  }
  /* NZS-CDR-GIFTGATE: single owner of the blocked state, because render() has TWO exits -- the
     empty-cart early return below and the normal path. "Remove all items" on a gift-only cart takes
     the early one, so without calling this there too the anchor would stay greyed and untabbable
     over an empty cart, with the note still showing. */
  function coGate(blocked){
    _giftGate=blocked; /* NZS-CDR-DISC-0922: busy checkout must not display the gift-only explanation. */
    blocked=blocked||_codeBusy||_codeUncertain; /* NZS-CDR-DISC-0922: no checkout mid-change or on uncertain recovery. */
    var a=document.getElementById('nzsCdrCheckout'), n=document.getElementById('nzsCdrGiftnote');
    if(a){
      a.classList.toggle('is-blocked',blocked);
      if(blocked){ a.setAttribute('aria-disabled','true'); a.setAttribute('tabindex','-1'); }
      else { a.removeAttribute('aria-disabled'); a.removeAttribute('tabindex'); }
    }
    if(n) n.hidden=!_giftGate; /* NZS-CDR-DISC-0922 */
  }
  function render(cart,options){ /* NZS-CDR-DISC-0922: distinguish cached enrichment from fresh cart responses. */
    currentCart=cart; if(cart&&cart.items) rekeyPending(cart); /* NZS-CDR-REKEY-1009 */
    /* NZS-CDR-DISC-0922: render is the sole owner of the applied-code row, including empty carts. */
    _lastCart=cart; codePaint(cart,options);
    document.dispatchEvent(new CustomEvent('nzs:cart-rendered',{detail:{cart:cart}})); /* NZS-PDP-0916: refresh product exclusions after settled cart renders. */ /* NZS-CDR-COLLAPSE: last accepted server cart, read by effectiveItemCount(). */
    /* NZS-KITE-RM-0828: the NZS-NOSAMPLES stripper (Kite's auto-added free-samples
       placeholder, product 8957551313094) is removed — the Kite app is inactive. */
    /* NZS-OFFERS-0820 r3: tier-gift housekeeping. (1) A tier whose qualifying total (paid
       items only — a gift can never help unlock itself) has fallen below its threshold loses
       its gift lines: the automatic discount would stop applying and the line would silently
       start charging. (2) Gift units beyond the tier's entitlement are trimmed. Both are
       session-capped per tier so app re-adds can never loop; Pick-a-Card gifts (other
       _nzs_gift values) are never touched. */
    /* NZS-CDR-NOSHIFT-0922 R4: foreign-cart fallback is one batch per tier, on the same chain.
       Pending paid intents own their gift cleanup; never race them from an intermediate render. */
    if(!Object.keys(pending).some(function(k){return !pending[k].giftOwner;})) REWARDS.forEach(function(t){
      if(!t.opts||!t.opts.length||_tierDropQueued[t.amt]) return;
      var lines=tierLines(cart,t), cap=1; t.opts.forEach(function(o){cap=Math.max(cap,o.qty|0);});
      var _units=lines.reduce(function(n,it){return n+it.quantity;},0), _charged=lines.filter(nzsGiftNotFree);
      if(!lines.length||((giftQual(cart)>=t.amt||!_charged.length)&&_units<=cap)) return; /* NZS-CDR-QUAL-0923: only a gift the server CHARGES is dropped below a tier */
      _tierDropQueued[t.amt]=true;
      queueCart(function(){
        if(Object.keys(pending).some(function(k){return !pending[k].giftOwner;})) return;
        var fresh=tierLines(currentCart,t), units=fresh.reduce(function(n,it){return n+it.quantity;},0);
        var drop=giftQual(currentCart)<t.amt?fresh.filter(nzsGiftNotFree):[]; if(!drop.length&&units>cap) drop=fresh.slice(-1); /* NZS-CDR-QUAL-0923: server-free gifts stay */
        if(!drop.length) return;
        try{ var ck='nzsTierDrop-'+t.amt, count=parseInt(sessionStorage.getItem(ck)||'0',10); if(count>=4) return; sessionStorage.setItem(ck,String(count+1)); }catch(_){}
        var seq=++_cartSeq, updates={}; drop.forEach(function(it){updates[it.key]=0;});
        return dropGiftBatch(updates,seq).then(function(c){if(seq===_cartSeq&&c) render(c);}).catch(function(){if(seq===_cartSeq) return fetchCart();});
      }).finally(function(){delete _tierDropQueued[t.amt];});
    });
    var qty=Number(cart.item_count); if(!isFinite(qty)) qty=0;
    setBadge(qty);
    if(qty>0 && drawer.classList.contains('is-open') && window.__nzsCoPrefetch) window.__nzsCoPrefetch(); /* checkout prefetch lives in a separate IIFE (NZS-CDR-CHECKOUT) — namespaced global, guarded for absence */
    if(!cart.items||!cart.items.length){
      paintEmpty(); _patchEnrichment=null; /* NZS-CDR-EMPTY-0922 */
      if(footEl) footEl.style.display='none';
      coGate(false);   /* NZS-CDR-GIFTGATE: an empty cart is not a gift-only cart */
      /* NZS-CDR-DISC-0922: no input on an empty cart; session code is retained and repainted on add. */
      updateReward(cart);
      loadRecs(cart);
      offersAfterRender(cart);   /* NZS-OFFERS-0820 */
      return;
    }
    if(subtEl) subtEl.textContent=money(cart.total_price); coPrice(); /* NZS-CDR-CO-PRICE-0924 */
    /* Per-line discount resolution for the drawer display. Precedence (mutually exclusive,
       never double-counted): free gift (tier-aware via _earned: sample>=3, mystery>=4 picks) ->
       subscription -> stack % -> existing line discount. */
    /* NZS-CDR-NOSHIFT-0922: only unresolved lines need the fallback. */
    _lastCart=cart; useLines(cart); loadRrp(cart);                                          /* NZS-CDR-RRP */
    var _attrs=cart.attributes||{};
    var _cdrPk={}; (cart.items||[]).forEach(function(it){ var p=it.properties||{}; if(p._Stack && !p._Free && p.Category) _cdrPk[String(p.Category).toLowerCase()]=1; });
    var _picks=Object.keys(_cdrPk).length, _stackPct=_picks>=4?10:_picks>=2?5:0;
    function lineDiscPair(it){
      var props=it.properties||{}, qty=it.quantity||1, orig=it.original_line_price||it.final_line_price;
      var _rl=rrpFor(it)*qty;                                              /* NZS-CDR-RRP: compare-at line total, 0 if not on sale */
      var _old=Math.max(orig,_rl);                                         /* RRP folds into `old`, never stacks on a discount */
      if(props._nzs_gift){
        /* NZS-OFFERS-0820 r3: tier gifts are REAL products zeroed by the automatic "NZS Reward"
           discounts, so show the SERVER's price truth — final_line_price is 0 only when the
           discount genuinely applied, and the 80%-off reward shows its real discounted price.
           Pick-a-Card gifts are $0-priced products, so they resolve free here unchanged. */
        return {old:_old,nw:it.final_line_price,free:it.final_line_price===0};
      }
      /* NZS-CDR-DISC-0922: code-discounted paid lines retain controls and use server final prices,
         including subscriptions and stacks. A zero price alone does not prove gift ownership. */
      if(codeList(cart).length){
        var sp=it.selling_plan_allocation;
        return {old:Math.max(_old,sp&&sp.compare_at_price!=null?sp.compare_at_price*qty:0),nw:it.final_line_price,free:!!props._Free&&it.final_line_price===0};
      }
      if(props._Free){ var _earned=/mystery/i.test(props._Free)?_picks>=4:_picks>=3; return _earned?{old:_old,nw:0,free:true}:{old:_old,nw:orig}; }
      var spa=it.selling_plan_allocation;                                  /* subscription: real discount lives here, per-unit */
      if(spa&&spa.compare_at_price!=null&&spa.price!=null&&spa.compare_at_price>spa.price) return {old:Math.max(spa.compare_at_price*qty,_rl),nw:spa.price*qty};
      if(_stackPct>0&&props._Stack) return {old:_old,nw:Math.round(orig*(1-_stackPct/100))};  /* paid stack pick (one-time) */
      /* NZS-OFFERS-0820 r12 (Blake): a line the automatic reward discount zeroed server-side
         is a free gift even without _nzs_gift props (BXGY allocates to its own pick of eligible
         line) -- tag it and swap its stepper. orig>0 keeps genuinely $0-priced lines untouched. */
      return {old:_old,nw:it.final_line_price,free:it.final_line_price===0&&orig>0};
    }
    /* per-unit old/new, stashed on the row so the optimistic qty path can rescale them instantly */
    function _uo(it){ var q=it.quantity||1, p=lineDiscPair(it); return Math.round(p.old/q); }
    function _un(it){ var q=it.quantity||1, p=lineDiscPair(it); return p.free?0:Math.round(p.nw/q); }
    /* NZS-CDR-DISC-0922: order allocations are not included in final_line_price. Count them once. */
    var _totalSave=cart.items.reduce(function(s,it){var p=lineDiscPair(it);return s+(p.old-p.nw);},0)+codeOrderDiscount(cart);
    _serverSavings=_totalSave;
    var _savEl=document.getElementById('nzsCdrSavings'), _savAmt=document.getElementById('nzsCdrSavingsAmt');
    savingsPaint(_totalSave,cart.items.some(function(it){return !linesKnown(it);})); /* NZS-CDR-NOSHIFT-0922 */
    if(footEl) footEl.style.display='';
    /* NZS-CDR-GIFTGATE: every line is a gift -> nothing to pay for, so block Checkout. A gift is
       either a Pick-a-Card line (_nzs_gift) or one the pricing above already resolved to free (an
       EARNED stack sample / mystery gift). An UNEARNED _Free line still charges money, so it counts
       as PAID and unblocks -- the shopper really is buying something. Runs on every render, so it
       unblocks the moment a paid line lands. */
    coGate(cart.items.length>0 && cart.items.every(function(it){
      return !!(it.properties&&it.properties._nzs_gift) || lineDiscPair(it).free===true;
    }));
    /* per-item price markup, shared by the full rebuild and the in-place patch path below */
    function priceHtmlFor(it){
      /* NZS-CDR-NOSHIFT-0922: no provisional savings or price geometry. */
      if(!linesKnown(it)&&!_rrpFailed[it.handle||it.product_id]) return '<span class="nzs-cdr__price-skeleton" aria-hidden="true"><i></i><i></i></span>';
      var _pp=lineDiscPair(it), _sv=_pp.old-_pp.nw;
      return _pp.free
        ? '<div class="nzs-cdr__prices">'+(_pp.old>0?'<span class="nzs-cdr__item-price--old">'+money(_pp.old)+'</span>':'')+'<span class="nzs-cdr__item-price nzs-cdr__item-price--new nzs-cdr__free-pill">FREE</span></div>'   /* NZS-GIFTLOCK: a pick-a-card gift has no RRP, so striking through $0.00 would be noise */
        : (_sv>0
          ? '<div class="nzs-cdr__prices"><span class="nzs-cdr__item-price--old">'+money(_pp.old)+'</span><span class="nzs-cdr__item-price nzs-cdr__item-price--new">'+money(_pp.nw)+'</span></div><span class="nzs-cdr__item-save"'+(_sv<100?' hidden':'')+'>Save '+money(_sv)+'</span>' /* NZS-CDR-FINISH-0923: savings under $1 read as cheap */
          : '<span class="nzs-cdr__item-price">'+money(_pp.nw)+'</span>');
    }
    /* same line keys as the current DOM (no add/remove) → patch qty/price in place instead of
       rebuilding, so images/scroll position don't flicker on a plain qty change */
    var _domKeys=Array.prototype.map.call(itemsEl.querySelectorAll('.nzs-cdr__item'),function(r){return r.dataset.key;});
    var _newKeys=cart.items.map(function(it){return it.key;});
    var _samePatch=_domKeys.length===_newKeys.length && _domKeys.every(function(k){return _newKeys.indexOf(k)>-1;});
    /* NZS-OFFERS-0820 r12: same keys but a flipped gift/lock state (reward discount zeroed a
       line, or it went back to paid) needs its controls swapped -- force the rebuild. */
    if(_samePatch){ _samePatch=cart.items.every(function(it){
      var row=itemsEl.querySelector('[data-key="'+it.key+'"]');
      var p=it.properties||{}, pp=lineDiscPair(it);
      var g=nzsGiftLocked(it,pp); /* NZS-CDR-QUAL-0923: an undiscounted tier gift is not locked */
      return !!row && (row.dataset.lock==='1')===g;
    }); }
    /* NZS-CDR-NOSHIFT-0922: enrichment never changes keys or rebuilds a row. */
    cart.items.forEach(function(it){ if(!linesKnown(it)){ _priceReserved[it.key]=true; _subReserved[it.key]=true; } });
    _patchEnrichment=function(){
      if(currentCart!==cart) return;
      cart.items.forEach(function(it){
        var row=cdrRow(it.key); if(!row) return;
        row.dataset.unitOld=_uo(it); row.dataset.unitNew=_un(it);
        var pw=row.querySelector('.nzs-cdr__price-wrap'); if(pw) pw.innerHTML=priceHtmlFor(it);
        var slot=row.querySelector('.nzs-cdr__sub-slot');
        if(slot&&!slot.querySelector('button')) slot.innerHTML=subAction(it,row.dataset.lock==='1'||!!(it.properties||{})._nzs_gift) /* NZS-CDR-QUAL-0923 */;
        /* NZS-CDR-ROWFIT-1006: info known, so release the open-time reserve; rows fit their content (Blake). */
        if(pw) pw.classList.remove('is-reserved'); if(slot) slot.classList.remove('is-reserved'); delete _priceReserved[it.key]; delete _subReserved[it.key];
      });
      _serverSavings=cart.items.reduce(function(s,it){var p=lineDiscPair(it);return s+p.old-p.nw;},0)+codeOrderDiscount(cart);
      savingsPaint(_serverSavings,cart.items.some(function(it){return !linesKnown(it);}));
      applyPending();
    };
    if(_samePatch){
      cart.items.forEach(function(it){
        var row=itemsEl.querySelector('[data-key="'+it.key+'"]'); if(!row) return;
        row.dataset.unit=it.final_price; row.dataset.unitOld=_uo(it); row.dataset.unitNew=_un(it);
        row.style.display='';
        var qn=row.querySelector('.nzs-cdr__qty-n'); if(qn) qn.textContent=it.quantity;
        /* NZS-GIFTLOCK: the in-place patch path keeps the same DOM, so a locked row's static
           quantity lives in two places that both have to be refreshed here -- the chip text and
           data-lockqty. Re-picking a gift already in the cart merges into the same line key, which
           takes this path, not the full rebuild. */
        if(row.dataset.lock!=='1'&&row.dataset.lockqty!=null) row.dataset.lockqty=it.quantity; /* NZS-CDR-QUAL-0923: "Not free yet" gift rows */
        if(row.dataset.lock==='1'){ row.dataset.lockqty=it.quantity;
          var _gl=row.querySelector('.nzs-cdr__giftlock'); if(_gl) _gl.textContent='Free gift'+(it.quantity>1?' \u00d7 '+it.quantity:''); }
        row.querySelectorAll('[data-act]').forEach(function(b){ b.dataset.qty=it.quantity; });
        var pw=row.querySelector('.nzs-cdr__price-wrap'); if(pw) pw.innerHTML=priceHtmlFor(it);
        /* NZS-CDR-NOSHIFT-0922: retain a user's open subscription panel. */
        var slot=row.querySelector('.nzs-cdr__sub-slot'); if(slot&&!slot.querySelector('button')) slot.innerHTML=subAction(it,row.dataset.lock==='1'||!!(it.properties||{})._nzs_gift) /* NZS-CDR-QUAL-0923 */;
      });
    } else {
      /* NZS-CDR-PERKROW (Blake 2026-07-31): a claimed email perk shows as its own line
         at the top of the cart. cart.js exposes cart attributes; the nzs-stack-lockdown
         function's ORDER branch grants the discount itself at checkout. */
      var _perkRow=(cart.attributes&&cart.attributes._EmailPerk==='pick-a-card')
        ? '<div class="nzs-cdr__perkrow"><span class="nzs-cdr__perkrow-ic">'+rwIcon('percent')+'</span><span><b>Subscriber perk</b>: 2.5% off your order, applied at checkout</span></div>' /* NZS-UPSELL-0911: ponytail: edit the existing hook instead of a second implementation. */
        : '';
      itemsEl.innerHTML=_perkRow+cart.items.map(function(it,_i){
        var title=esc(it.product_title||it.title||''), imageUrl=it.image?String(it.image):'';
        var img=imageUrl?'<img src="'+esc(imageUrl+(imageUrl.indexOf('?')>-1?'&width=144':'?width=144'))+'" alt="'+title+'" loading="eager">':''; /* NZS-CDR-PRELOAD-1009: shut-drawer rows load their thumb before the open */
        var vt=it.variant_title&&it.variant_title!=='Default Title'?'<div class="nzs-cdr__item-variant">'+esc(it.variant_title)+'</div>':'';
        var _sp=it.selling_plan_allocation&&it.selling_plan_allocation.selling_plan?esc(it.selling_plan_allocation.selling_plan.name):'';
        var subHtml=_sp?'<div class="nzs-cdr__item-sub"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M3 2v6h6"/><path d="M21 12A9 9 0 0 0 6 5.3L3 8"/><path d="M21 22v-6h-6"/><path d="M3 12a9 9 0 0 0 15 6.7l3-2.7"/></svg>'+_sp+'</div>':'';
        var url=esc(it.url||'#'), key=esc(it.key);
        /* NZS-GIFTLOCK: the free-samples placeholder is a promo line the customer never chose to buy —
           it is added/removed by the gift app, so the drawer shows it read-only: no qty stepper, no Remove. */
        var _dp=it.properties||{}, _pp2=lineDiscPair(it);
        var _giftNotFree=nzsGiftNotFree(it); /* NZS-CDR-QUAL-0923 */
        var _discTag=_dp._nzs_gift?(_pp2.free?'Free gift reward':(_giftNotFree?(nzsQual(cart).bundle?'Not free yet: bundle deals don\u2019t count toward gift rewards':'Not free yet: this reward isn\u2019t unlocked'):'Reward discount')):(_pp2.free?(_dp._Free?'Free with your Build Your Stack':'Free gift reward'):((_stackPct>0&&_dp._Stack&&!_dp._Free)?_stackPct+'% off your stack':''));
        /* NZS-GIFTLOCK covers two cases, both of which display as FREE (NZS-KITE-RM-0828:
           the Kite free-samples placeholder case is removed — app inactive):
             1. a "Pick a Card" gift (_nzs_gift, added at $0 by nzs-gift-popup.js),
             2. any line the pricing above already resolved to free -- i.e. an EARNED stack
                sample / mystery gift.
           An UNEARNED _Free line is NOT locked on purpose: it still charges full price, so the
           shopper must keep the stepper and Remove to be able to get rid of it. */
        var _isGift=nzsGiftLocked(it,_pp2); /* NZS-CDR-QUAL-0923: a charged tier gift keeps Remove, never the FREE chip */
        /* NZS-CDR-SUBUP: a gift is never offered a subscription -- it is not a purchase. A paid
           one-time line whose product has 10%-discount week plans gets the pill; an already-subscribed
           paid line gets the way back out; a product with no week plans gets neither. Plans are empty
           until the /products/<handle>.js fetch lands, which is what _plansDirty re-renders for. */
        /* NZS-CDR-NOSHIFT-0922: unresolved plans get the same space as the final control. */
        var _subupHtml='<div class="nzs-cdr__sub-slot'+(_subReserved[it.key]?' is-reserved':'')+'">'+subAction(it,_isGift||_giftNotFree)+'</div>';
        var discHtml=_discTag?'<div class="nzs-cdr__item-disc"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M19 5 5 19"/><circle cx="6.5" cy="6.5" r="2.5"/><circle cx="17.5" cy="17.5" r="2.5"/></svg><span>'+esc(_discTag)+'</span></div>':'';
        /* NZS-CDR-PRICE-UP (Blake 2026-08-03): price + Save move into .nzs-cdr__item-head next to the
           title; the stepper and the trash icon are the only things left on .nzs-cdr__item-row.
           .nzs-cdr__item-end is gone. Gift rows still emit neither a stepper nor a remove control. */
        var _rmBtn='<button class="nzs-cdr__item-remove" type="button" data-act="remove" data-key="'+key+'" title="Remove" aria-label="Remove '+title+'"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="18" height="18" aria-hidden="true" focusable="false"><path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"/><path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"/></svg></button>';
        /* r12: zeroed by the reward discount but customer-added -> tag + lock qty, KEEP Remove */
        var _organicFree=_isGift&&!_dp._nzs_gift&&!_dp._Free; /* NZS-KITE-RM-0828 */
        /* NZS-CDR-NOSHIFT-0922: retain unresolved row slots for this open. */
        return '<div class="nzs-cdr__item" style="--i:'+_i+'"'+(_isGift?' data-lock="1" data-lockqty="'+it.quantity+'"':(_giftNotFree?' data-lockqty="'+it.quantity+'"':''))+' data-key="'+key+'" data-pid="'+it.product_id+'" data-variant="'+it.variant_id+'" data-unit="'+it.final_price+'" data-unit-old="'+_uo(it)+'" data-unit-new="'+_un(it)+'"><div class="nzs-cdr__thumb">'+(_isGift?'<span class="nzs-cdr__item-img">'+img+'</span>':'<a class="nzs-cdr__item-img" href="'+url+'">'+img+'</a>')+'</div><div class="nzs-cdr__item-body"><div class="nzs-cdr__item-head">'+(_isGift?'<span class="nzs-cdr__item-title nzs-cdr__item-title--plain">'+title+'</span>':'<a class="nzs-cdr__item-title" href="'+url+'">'+title+'</a>')+'<div class="nzs-cdr__price-wrap'+(_priceReserved[it.key]?' is-reserved':'')+'">'+priceHtmlFor(it)+'</div></div>'+(_isGift?'':jmRowFor(it))+vt+subHtml+discHtml+'<div class="nzs-cdr__item-row">'+(_isGift?'<span class="nzs-cdr__giftlock">Free gift'+(it.quantity>1?' \u00d7 '+it.quantity:'')+'</span>'+(_organicFree?_rmBtn:''):(_giftNotFree?'':'<div class="nzs-cdr__qty"><button class="nzs-cdr__qty-btn" type="button" data-act="minus" data-key="'+key+'" data-qty="'+it.quantity+'" aria-label="Decrease quantity, '+title+'">&minus;</button><span class="nzs-cdr__qty-n">'+it.quantity+'</span><button class="nzs-cdr__qty-btn" type="button" data-act="plus" data-key="'+key+'" data-qty="'+it.quantity+'" aria-label="Increase quantity, '+title+'">+</button></div>')+_rmBtn+'')+'</div>'+_subupHtml+'</div></div>';   /* NZS-CDR-SUBUP: after .nzs-cdr__item-row, still inside .nzs-cdr__item-body */
      }).join('');
    }
    updateReward(cart);
    loadRecs(cart);
    offersAfterRender(cart);   /* NZS-OFFERS-0820 */
    applyPending(); /* NZS-CDR-DISC-0922: pending intents must be the last paint. */
  }
  /* optimistic qty/remove: instant local update + un-hide, debounced single /cart/change.js per
     line, delegated so it survives both the patch and the full-rebuild paths above */
  var pending={}, _tierDropQueued={}; /* NZS-CDR-NOSHIFT-0922 R4: one housekeeping batch per tier. */
  var chgChain=Promise.resolve();
  /* NZS-CDR-DISC-0922: every drawer change/update transaction enters the same chain.
     The optional probe observes link lifetime, before the transport guard can mask overlap. */
  var _chainInFlight=0, _giftAddInLink=null; /* NZS-CDR-SPEED-0922: exact owner of the gift add event. */
  function queueCart(task){
    var next=chgChain.then(function(){
      ++_chainInFlight; chainProbe('entry');
      return Promise.resolve().then(task).finally(function(){ --_chainInFlight; chainProbe('settle'); });
    });
    chgChain=next.catch(function(){});
    return next;
  }
  function chainProbe(phase){
    if(typeof window.__nzsCdrChainProbe==='function'){
      try{ window.__nzsCdrChainProbe(phase,_chainInFlight); }catch(_){}
    }
  }
  /* NZS-CDR-COLLAPSE state. collapseByKey holds at most one live animation per line;
     lineIntent is a monotonic per-line click counter (never reset -- reusing a number could
     let an ancient animation match a future click); currentCart is the last accepted server
     cart, needed to decide whether a removal empties the cart. */
  var collapseByKey={}, lineIntent={}, currentCart=null;
  var cdrReduce=window.matchMedia?window.matchMedia('(prefers-reduced-motion: reduce)'):{matches:false};
  function cdrRow(key){ return itemsEl.querySelector('[data-key="'+key+'"]'); }
  /* NZS-CDR-REKEY-1009 (Blake: fast variety-pack removes came back): Shopify re-keys every line whose discount allocation
     changes, so one pack remove re-keys the rest and a queued remove 400'd into "already gone" (line kept, row shown).
     Pending state follows its line by identity (variant + plan + properties); a queued link re-reads its key at the head. */
  var _lineIdent={}, _rekey={};
  function identOf(it){ var sp=it.selling_plan_allocation&&it.selling_plan_allocation.selling_plan; return it.variant_id+'|'+(sp?sp.id:'')+'|'+JSON.stringify(it.properties||{}); }
  function rekeyed(k){ for(var n=0;_rekey[k]&&n<20;n++) k=_rekey[k]; return k; }
  function rekeyPending(cart){
    var byIdent={}, has={};
    (cart.items||[]).forEach(function(it){ has[it.key]=1; byIdent[identOf(it)]=it.key; });
    Object.keys(pending).forEach(function(k){
      var nk=byIdent[_lineIdent[k]];
      if(has[k]||!nk||nk===k||pending[nk]||pending[k].giftOwner) return; /* gift tombstones keep their own owner map */
      pending[nk]=pending[k]; delete pending[k]; _rekey[k]=nk;
      if(lineIntent[k]!=null) lineIntent[nk]=lineIntent[k];
      if(collapseByKey[k]){ collapseByKey[nk]=collapseByKey[k]; collapseByKey[nk].key=nk; delete collapseByKey[k]; }
    });
    (cart.items||[]).forEach(function(it){ _lineIdent[it.key]=identOf(it); delete _rekey[it.key]; }); /* a live key never redirects (keys can recur) */
  }
  /* NZS-CDR-SETTLE-1009 (Blake): two or more lines changing at once = the server re-prices (pack %, tiers), so the
     optimistic totals are guesses. Skeleton them (CC style) until every write has landed; single taps stay instant. */
  var _settleOn=false;
  function settleSkel(){
    var n=Object.keys(pending).filter(function(k){ return !pending[k].giftOwner; }).length, on=_settleOn?n>0:n>1;
    if(on!==_settleOn){ _settleOn=on; drawer.classList.toggle('is-settling',on); }
  }
  function showBusy(row){
    if(!row) return;
    /* NZS-CDR-BUSY: hosted on the price wrap, not the thumbnail. is-busy hides the price stack
       underneath so the spinner lands exactly where the price was -- no overlap, no reflow. */
    var host=row.querySelector('.nzs-cdr__price-wrap'); if(!host||host.querySelector('.nzs-cdr__busy')) return;
    var sp=document.createElement('span'); sp.className='nzs-cdr__busy'; sp.setAttribute('aria-hidden','true');
    sp.innerHTML='<svg viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg" focusable="false"><circle cx="33" cy="33" r="30"></circle></svg>';
    host.appendChild(sp); host.classList.add('is-busy'); row.setAttribute('aria-busy','true');
  }
  function hideBusy(row){
    if(!row) return;
    row.removeAttribute('aria-busy');
    var host=row.querySelector('.nzs-cdr__price-wrap'); if(host) host.classList.remove('is-busy');
    var sp=row.querySelector('.nzs-cdr__busy'); if(sp&&sp.parentNode) sp.parentNode.removeChild(sp);
  }
  /* server quantities overridden by whatever is optimistically pending, so 'did that click
     empty the cart?' is answered against intent, not against stale DOM. */
  /* NZS-CDR-NOSHIFT-0922 R4: project original merchandise value, including subscription plan prices.
     This copy is used only for eligibility/reward UI, never as a server-confirmed pricing cart. */
  function projectedCart(cart){
    /* NZS-CDR-QUAL-0923: the totals are post-discount, so the optimistic copy scales the last server cart's per-unit
       FINAL prices (line discounts and their allocations ride along) and moves total_price by the same delta, which
       keeps the server's order discount constant. Server renders land on the same number unless a discount changes. */
    var dFinal=0;
    var items=((cart&&cart.items)||[]).map(function(it){
      var owner=pending[it.key]; if(!owner) return it;
      var q=it.quantity||1, fin=Number(it.final_line_price), nf;
      if(!isFinite(fin)) fin=Number(it.original_line_price)||0;
      nf=fin/q*owner.qty; dFinal+=nf-fin;
      return Object.assign({},it,{quantity:owner.qty,original_line_price:(Number(it.original_line_price)||0)/q*owner.qty,final_line_price:nf});
    }).filter(function(it){return it.quantity>0;});
    var out=Object.assign({},cart,{items:items,item_count:items.reduce(function(n,it){return n+it.quantity;},0)});
    if(cart&&cart.total_price!=null&&isFinite(Number(cart.total_price))) out.total_price=Number(cart.total_price)+dFinal;
    return out;
  }
  function projectedGiftDrops(owner){
    var projected=projectedCart(currentCart), total=giftQual(projected), doomed={}; /* NZS-CDR-QUAL-0923: gift tiers only */
    REWARDS.forEach(function(t){if(t.opts&&t.opts.length&&total<t.amt) tierLines(currentCart,t).forEach(function(it){doomed[it.key]=true;});});
    Object.keys(pending).forEach(function(k){if(pending[k].giftOwner&&!doomed[k]){delete pending[k];cancelCollapse(k,true);}});
    owner.doomed={};
    Object.keys(doomed).forEach(function(k){
      var giftOwner={qty:0,giftOwner:owner}; pending[k]=giftOwner; owner.doomed[k]=giftOwner;
      var intent=(lineIntent[k]||0)+1;lineIntent[k]=intent;
      var row=cdrRow(k);
      if(row&&row.style.display==='none') cancelCollapse(k,false);
      else beginCollapse(row,k,giftOwner,intent);
    });
  }
  function releaseGiftDrops(owner,restore){
    Object.keys((owner&&owner.doomed)||{}).forEach(function(k){
      if(pending[k]!==owner.doomed[k]) return;
      delete pending[k]; cancelCollapse(k,restore);
    });
  }
  function dropGiftBatch(updates,seq){
    if(seq!==_cartSeq||!Object.keys(updates).length) return Promise.resolve(null);
    return fetch(cartRoot+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({updates:updates}),__nzsCartGuardHandled:true})
      .then(function(r){if(!r.ok) throw 0;return r.json();})
      .then(function(c){if(!c||!c.items||!c.token) throw 0;return c;});
  }
  function commitGiftDrops(cart,seq,owner,key){
    if(seq!==_cartSeq||!cart||!cart.items||!cart.token||!owner||pending[key]!==owner) return Promise.resolve(cart);
    var total=giftQual(cart), projected=giftQual(projectedCart(cart)), updates={}; /* NZS-CDR-QUAL-0923 */
    REWARDS.forEach(function(t){
      if(t.opts&&t.opts.length&&total<t.amt&&projected<t.amt) tierLines(cart,t).forEach(function(it){ if(nzsGiftNotFree(it)) updates[it.key]=0; }); /* NZS-CDR-QUAL-0923: never drop a gift the server still discounts (the optimistic hide is released and the render restores it) */
    });
    return Object.keys(updates).length?dropGiftBatch(updates,seq).then(function(c){return c||cart;}):Promise.resolve(cart);
  }
  function effectiveItemCount(){
    var total=0, seen={};
    if(currentCart&&currentCart.items){
      currentCart.items.forEach(function(it){
        var k=String(it.key), owner=pending[k];
        seen[k]=1;
        total+=owner?owner.qty:(parseInt(it.quantity,10)||0);
      });
      Object.keys(pending).forEach(function(k){ if(!seen[k]) total+=parseInt(pending[k].qty,10)||0; });
      return total;
    }
    itemsEl.querySelectorAll('.nzs-cdr__item').forEach(function(row){
      var owner=pending[row.dataset.key], qn;
      if(owner){ total+=owner.qty; return; }
      qn=row.querySelector('.nzs-cdr__qty-n');
      total+=parseInt(qn?qn.textContent:(row.dataset.lockqty||0),10)||0;
    });
    return total;
  }
  function cancelCollapse(key,restore){
    var fx=collapseByKey[key], row;
    if(fx){ delete collapseByKey[key]; if(fx.animation) fx.animation.cancel(); if(fx.row) fx.row.classList.remove('is-collapsing'); }
    if(restore){ row=cdrRow(key); if(row){ row.classList.remove('is-collapsing'); row.style.display=''; } }
  }
  function finishCollapse(fx){
    if(collapseByKey[fx.key]!==fx){ fx.animation.cancel(); return; }
    var owner=pending[fx.key];
    var stillGoing=!owner||(owner===fx.owner&&owner.qty===0);
    delete collapseByKey[fx.key];
    /* hide BEFORE cancelling the fill:forwards effect, or the row flashes back at full height */
    if(fx.row.parentNode){ if(stillGoing) fx.row.style.display='none'; else fx.row.style.display=''; }
    fx.row.classList.remove('is-collapsing');
    fx.animation.cancel();
  }
  function beginCollapse(row,key,owner,intent){
    if(!row||pending[key]!==owner||owner.qty!==0||lineIntent[key]!==intent) return;
    cancelCollapse(key,false);
    /* last line out, reduced motion, or no WAAPI: hide instantly. The empty-cart branch is
       server-rendered, so animating the final row just delays it. */
    if(effectiveItemCount()===0||cdrReduce.matches||typeof row.animate!=='function'){ row.style.display='none'; return; }
    row.style.display='';
    row.classList.add('is-collapsing');
    var h=row.getBoundingClientRect().height;
    if(!h){ row.classList.remove('is-collapsing'); row.style.display='none'; return; }
    /* border-box means height:0 still floors at padding+border (14+14+1), so the row would stop
       at ~29px and then snap away. Collapse the box model in the same keyframes. */
    var _cs=getComputedStyle(row);
    var fx={key:key,row:row,owner:owner,intent:intent,animation:row.animate([
      {height:h+'px',paddingTop:_cs.paddingTop,paddingBottom:_cs.paddingBottom,borderBottomWidth:_cs.borderBottomWidth,opacity:1},
      {height:'0px',paddingTop:'0px',paddingBottom:'0px',borderBottomWidth:'0px',opacity:0}
    ],{duration:200,easing:'ease',fill:'forwards'})};
    collapseByKey[key]=fx;
    fx.animation.finished.then(function(){ finishCollapse(fx); },function(){});
  }
  function reflowTotals(){
    var sum=0, qsum=0, sav=0;
    itemsEl.querySelectorAll('.nzs-cdr__item').forEach(function(row){
      /* NZS-CDR-COLLAPSE: a collapsing row is still display:'' for 200ms. Counting it would
         make the subtotal, savings and badge visibly lag the animation. */
      if(row.style.display==='none'||row.classList.contains('is-collapsing')) return;
      /* NZS-GIFTLOCK: a locked row has no .nzs-cdr__qty-n to read, so fall back to the quantity
         stamped on the row -- otherwise every optimistic qty tweak on a paid line would briefly
         drop the gift's units out of the cart badge until the server response re-rendered. */
      var qn=row.querySelector('.nzs-cdr__qty-n'), q=parseInt(qn?qn.textContent:(row.dataset.lockqty||0),10)||0;
      sum+=(parseFloat(row.dataset.unit)||0)*q; qsum+=q;
      var uo=parseFloat(row.dataset.unitOld), un=parseFloat(row.dataset.unitNew);   /* NZS-CDR-RRP */
      if(!isNaN(uo)&&!isNaN(un)&&uo>un) sav+=(uo-un)*q;
    });
    /* NZS-CDR-DISC-0922: preserve order savings during optimistic quantity work. For codes,
       hold the last confirmed monetary totals until the server recalculates thresholds/allocations. */
    var orderSaving=codeOrderDiscount(currentCart);
    sum=Math.max(0,sum-orderSaving); sav+=orderSaving;
    if(codeList(currentCart).length||orderSaving){ sum=currentCart.total_price; sav=_serverSavings; }
    if(subtEl) subtEl.textContent=money(sum); coPrice(); /* NZS-CDR-CO-PRICE-0924 */
    settleSkel(); /* NZS-CDR-SETTLE-1009 */
    var _s=document.getElementById('nzsCdrSavings'), _sa=document.getElementById('nzsCdrSavingsAmt');
    savingsPaint(sav,!!(currentCart&&currentCart.items.some(function(it){return !linesKnown(it);}))); /* NZS-CDR-NOSHIFT-0922 */
    setBadge(qsum);
  }
  function applyPending(){
    settleSkel(); /* NZS-CDR-SETTLE-1009: render ends here, so the last landed write clears the skeleton */
    Object.keys(pending).forEach(function(k){
      var row=itemsEl.querySelector('[data-key="'+k+'"]'); if(!row) return;
      var nq=pending[k].qty;
      /* a rebuild render replaces the node and its pill: only restore one if this line's write
         is genuinely in flight. */
      if(pending[k].busyShown) showBusy(row); else hideBusy(row); /* NZS-CDR-BUSY-GRACE-0922 */
      /* NZS-CDR-COLLAPSE: preserve ONLY the exact animation this owner started on this very
         node. If a render replaced the row, the old animation is orphaned and the replacement
         is hidden in the same task -- otherwise a row mid-removal reappears at full height. */
      if(nq===0){
        var fx=collapseByKey[k];
        var live=!!(fx&&fx.owner===pending[k]&&fx.row===row&&fx.intent===lineIntent[k]&&row.parentNode);
        if(!live) row.style.display='none';
      }
      else { cancelCollapse(k,true);
             var qn=row.querySelector('.nzs-cdr__qty-n'); if(qn) qn.textContent=nq;
             row.querySelectorAll('[data-act]').forEach(function(b){ b.dataset.qty=nq; }); }
    });
    /* NZS-CDR-NOSHIFT-0922 R4: a server repaint must retain pending reward eligibility too. */
    if(Object.keys(pending).length){ reflowTotals(); updateReward(projectedCart(currentCart)); }
  }
  itemsEl.addEventListener('click',function(e){
    var btn=e.target.closest('[data-act]'); if(!btn) return;
    /* NZS-GIFTLOCK: the real lock. Locked rows render no [data-act] controls, but if one ever
       lands inside one (later render path, app injection, devtools) the optimistic qty/remove
       path refuses it here rather than queueing a /cart/change.js write. */
    if(btn.closest('.nzs-cdr__item[data-lock="1"]')) return;
    /* NZS-CDR-SUBUP: a selling_plan change re-keys the line, so a qty write debounced against the
       OLD key would 404 and bounce the row. The conversion is queued on chgChain and clears this
       flag when it settles; until then the stepper simply does not accept input. */
    if(_subBusy) return;
    var act=btn.dataset.act, key=btn.dataset.key, row=btn.closest('.nzs-cdr__item');
    var q=pending[key]?pending[key].qty:(parseInt(btn.dataset.qty,10)||0);
    var nq = act==='plus' ? q+1 : act==='minus' ? q-1 : 0;
    if(nq<0) nq=0;
    /* NZS-CDR-COLLAPSE: the owner object and its intent number exist BEFORE any DOM work so the
       animation can bind to this exact click. pending[key] is assigned here rather than after
       the optimistic paint; `q` above was already read, so nothing downstream changes. */
    if(pending[key]) clearTimeout(pending[key].timer);
    var _intent=(lineIntent[key]||0)+1; lineIntent[key]=_intent;
    var _owner={qty:nq,timer:null};
    pending[key]=_owner;
    projectedGiftDrops(_owner); /* NZS-CDR-NOSHIFT-0922 R4: gift tombstones share this click's ownership. */
    if(row){
      /* NZS-CDR-BUSY (Blake 2026-08-03): no pill here. The click is answered optimistically and
         a write may sit in the 300ms debounce or queue behind another line -- showing a spinner
         through all of that reads as "still loading" long after the UI has settled. The pill is
         raised where the request actually starts instead. */
      if(nq===0){ beginCollapse(row,key,_owner,_intent); }
      else {
        cancelCollapse(key,true);
        row.style.display='';
        var qn=row.querySelector('.nzs-cdr__qty-n'); if(qn) qn.textContent=nq;
        row.querySelectorAll('[data-act]').forEach(function(b){ b.dataset.qty=nq; });
        var _un2=parseFloat(row.dataset.unitNew); if(isNaN(_un2)) _un2=parseFloat(row.dataset.unit)||0;
        var _uo2=parseFloat(row.dataset.unitOld); if(isNaN(_uo2)) _uo2=_un2;
        var pe=row.querySelector('.nzs-cdr__item-price');
        if(pe && !pe.classList.contains('nzs-cdr__free-pill')) pe.textContent=money(_un2*nq);
        var oe=row.querySelector('.nzs-cdr__item-price--old');                       /* NZS-CDR-RRP */
        if(oe) oe.textContent=money(_uo2*nq);
        var se=row.querySelector('.nzs-cdr__item-save');
        if(se && _uo2>_un2){ se.textContent='Save '+money((_uo2-_un2)*nq); se.hidden=(_uo2-_un2)*nq<100; } /* NZS-CDR-FINISH-0923 */
      }
    }
    reflowTotals(); updateReward(projectedCart(currentCart)); /* NZS-CDR-NOSHIFT-0922 R4: same-tick reward/badge. */
    _owner.timer=setTimeout(function(){
      queueCart(function(){ /* NZS-CDR-DISC-0922: shared chain. */
        var seq=++_cartSeq; key=rekeyed(key); /* NZS-CDR-REKEY-1009 */
        /* the write starts HERE -- past the debounce and at the head of the queue. */
        /* NZS-CDR-BUSY-GRACE-0922: grace begins at the write's chain head. */
        var _bo=pending[key]; if(_bo){ _bo.inflight=true; _bo.busyShown=false; _bo.busyT=setTimeout(function(){ if(pending[key]===_bo&&_bo.inflight){ _bo.busyShown=true; showBusy(cdrRow(key)); } },1000); }
        var owner=pending[key], tq=owner?owner.qty:nq; /* NZS-ROUND4-B-OWNER: one object owns this write. */
        var variantId=parseInt(row&&row.dataset.variant,10)||0;
        var started=Date.now(), budget=5600;
        function retryDelay(r,attempt){
          var raw=r.headers&&r.headers.get&&r.headers.get('Retry-After'), ms=NaN;
          if(raw){
            var seconds=Number(raw);
            ms=isNaN(seconds)?Date.parse(raw)-Date.now():seconds*1000;
          }
          if(!(ms>=0)) ms=attempt===0?600:1500;
          return Math.min(ms,4000,Math.max(0,budget-(Date.now()-started)));
        }
        function changeLine(id,attempt){
          return fetch(cartRoot+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:id,quantity:tq}),__nzsCartGuardHandled:true})
            .then(function(r){
              if(r.ok) return r.json();
              if((r.status===429||r.status>=500)&&attempt<2&&(Date.now()-started)<budget){
                return new Promise(function(resolve){ setTimeout(resolve,retryDelay(r,attempt)); })
                  .then(function(){ return changeLine(id,attempt+1); });
              }
              /* NZS-CDR-STOCKMSG-0821: keep Shopify's error body (422 stock cap says exactly
                 what happened, e.g. "All 2 ... are in your cart") instead of discarding it. */
              return r.json().catch(function(){ return null; }).then(function(body){
                var err=new Error("Couldn't update cart"); err.status=r.status;
                if(body&&(body.description||body.message)) err.cartMessage=String(body.description||body.message);
                throw err;
              });
            });
        }
        function writeChange(){
          return changeLine(key,0).catch(function(err){
            if((err.status!==400&&err.status!==404)||(!variantId&&tq!==0)) throw err;
            return fetch(cartRoot+'cart.js',{headers:{'Accept':'application/json'}})
              .then(function(r){ if(!r.ok) throw new Error("Couldn't update cart"); return r.json(); })
              .then(function(cart){
                var fresh=null, id=_lineIdent[key]; /* NZS-CDR-REKEY-1009: the same line under a new key first */
                (cart.items||[]).some(function(it){ if(id&&it.key!==key&&identOf(it)===id){ fresh=it; return true; } return false; });
                if(!fresh&&tq===0&&id){ /* stack re-tier swaps the plan (re-key): same variant + properties, only if unique */
                  var _np=id.replace(/^(\d+)\|[^|]*\|/,'$1||'), _m=(cart.items||[]).filter(function(it){ return identOf(it).replace(/^(\d+)\|[^|]*\|/,'$1||')===_np; });
                  if(_m.length===1&&_m[0].key!==key) fresh=_m[0];
                }
                if(!fresh&&tq!==0) (cart.items||[]).some(function(it){
                  if(String(it.variant_id)===String(variantId)){ fresh=it; return true; }
                  return false;
                });
                if(!fresh){ if(tq===0) return {nzsGone:true}; var missing=new Error("Couldn't update cart"); missing.status=404; throw missing; }
                return changeLine(fresh.key,0);
              });
          });
        }
        return writeChange()
          .then(function(cart){ return commitGiftDrops(cart,seq,owner,key); }) /* NZS-CDR-NOSHIFT-0922 R4: one follow-up batch, before the only render. */
          .then(function(cart){
            key=rekeyed(key); /* NZS-CDR-REKEY-1009 */
            if(_bo){ clearTimeout(_bo.busyT); _bo.inflight=false; _bo.busyShown=false; } /* NZS-CDR-BUSY-GRACE-0922 */
            releaseGiftDrops(owner,seq!==_cartSeq); /* NZS-CDR-NOSHIFT-0922 R4: stale reads must not leave orphaned hidden rows. */
            if(owner&&pending[key]===owner){ delete pending[key];
              /* NZS-CDR-COLLAPSE: the write landed. Keep a removed row hidden (restore:false) --
               the render below rebuilds from server truth anyway; restoring it here would
               flash the row back for one frame. */
              var _sr=cdrRow(key); if(tq===0&&_sr) _sr.style.display='none';
              cancelCollapse(key,false); hideBusy(_sr); }
            settleSkel(); /* NZS-CDR-SETTLE-1009: a stale last write still ends the burst */
            if(seq!==_cartSeq) return; /* NZS-CDR-NOSHIFT-0922 R4: a stale result cannot batch or paint. */
            if(cart&&cart.nzsGone) return fetchCart();
            if(cart && cart.items && cart.token){
              render(cart);
              /* NZS-CDR-SPEED-0922: delayed truth check only where gifts/discount allocation can lag. */
              if(codeList(cart).length||cart.items.some(function(it){ return (it.properties||{})._nzs_gift||it.final_line_price===0; }))
                setTimeout(function(){ if(seq===_cartSeq) fetchCart(); },1400);
            } else { fetchCart(); }
          })
          .catch(function(err){
            key=rekeyed(key); /* NZS-CDR-REKEY-1009 */
            if(_bo){ clearTimeout(_bo.busyT); _bo.inflight=false; _bo.busyShown=false; } /* NZS-CDR-BUSY-GRACE-0922 */
            releaseGiftDrops(owner,true); /* NZS-CDR-NOSHIFT-0922 R4: never delete a newer click's tombstones. */
            if(owner&&pending[key]===owner){ delete pending[key];
              /* NZS-CDR-COLLAPSE: the write did not land, so put the row back. Only this owner
               may do it -- a newer click's collapse must survive an older failure. */
              cancelCollapse(key,true); hideBusy(cdrRow(key)); reflowTotals(); }
            /* NZS-CDR-VERIFY-FAIL (Blake 2026-08-01): a thrown update is not proof the update
               failed -- a bot-challenge 200 with an HTML body lands here with the change already
               processed. Ask /cart.js what actually happened and only alarm when the intended
               quantity genuinely is not there. fetchCart() resyncs the UI either way. */
            return fetch(cartRoot+'cart.js',{headers:{'Accept':'application/json'}}) /* NZS-CDR-DISC-0922: retain link through reconciliation. */
              .then(function(r){ return r.ok?r.json():null; })
              .catch(function(){ return null; })
              .then(function(cart){
                /* NZS-CDR-NOSHIFT-0922 R4: reconcile once and restore from server truth, including 422. */
                if(seq!==_cartSeq) return;
                if(cart&&cart.items&&cart.token) render(cart); else fetchCart();
                var applied=false;
                if(cart&&cart.items){
                  var line=null;
                  cart.items.some(function(it){
                    if(String(it.key)===String(key)||(variantId&&String(it.variant_id)===String(variantId))){ line=it; return true; }
                    return false;
                  });
                  applied = tq===0 ? !line : !!(line&&line.quantity===tq);
                }
                if(!applied){
                  /* NZS-CDR-STOCKMSG-0821: when Shopify told us WHY (stock cap), say that instead
                     of the generic alarm. Count parsed from its message; singular-aware. */
                  var detail={message:"Couldn't update your cart. Please try again"}; /* NZS-UPSELL-0911: ponytail: edit the existing hook instead of a second implementation. */
                  var cm=err&&err.cartMessage;
                  if(err&&err.status===422&&cm&&/your cart|only add|can’t add|can't add|sold out|availab|stock/i.test(cm)){
                    detail.title="Stock limit reached";
                    var m=/\b(?:all|only)\s+(\d+)\b/i.exec(cm), n=m?parseInt(m[1],10):0;
                    var pname=(line&&line.product_title)||"items";
                    if(n===1){
                      detail.message="The last one in stock is already in your cart.";
                    } else if(n>1){
                      var msg="All "+n+" "+pname+" are in your cart.";
                      if(msg.length>60) msg="All "+n+" items are in your cart.";
                      detail.message=msg;
                    } else {
                      detail.message=cm;
                    }
                  }
                  document.dispatchEvent(new CustomEvent('nzs:cart-error',{detail:detail}));
                }
              });
          });
      });
    },300);
  });
  var _cartSeq=0, _cartReady=false, _cartRetryTimer=null, _cartRetryN=0;
  function fetchOnce(seq){
    var ctl=('AbortController' in window)?new AbortController():null, t=setTimeout(function(){ if(ctl) ctl.abort(); }, 8000);
    var p=fetch(cartRoot+'cart.js', ctl?{signal:ctl.signal}:{});
    p.then(function(){ clearTimeout(t); }, function(){ clearTimeout(t); });
    return p.then(function(r){ if(!r.ok) throw 0; return r.json();}).then(function(c){ if(seq!==_cartSeq) return; if(c && c.items && c.token){ _cartRetryN=0; return paintOpenCart(c,seq); /* NZS-CDR-NOSHIFT-0922 */ } else { throw 0; } });
  }
  function fetchCart(){ var seq=++_cartSeq;
    return fetchOnce(seq)
      .catch(function(){ /* ponytail: one retry so a transient /cart.js blip never leaves the drawer stuck empty */
        return fetchOnce(seq).catch(function(){
          /* NZS-CDR-RETRY: both attempts failed. ponytail: 3 auto retries per open (counter resets on success/open), then manual tap only; no infinite polling. */
          if(seq!==_cartSeq || !drawer.classList.contains('is-open')) return;
          itemsEl.innerHTML='<div class="nzs-cdr__empty nzs-cdr__retry">Couldn\'t load your cart.<br><button type="button" class="nzs-cdr__retrybtn">Tap to retry</button></div>';
          if(!_cartRetryTimer && _cartRetryN<3){ _cartRetryN++; _cartRetryTimer=setTimeout(function(){ _cartRetryTimer=null; if(drawer.classList.contains('is-open') && !_cartReady) fetchCart(); }, 2000); }
        });
      });
  }
  /* NZS-CART-DRAWER-GIFT-RESYNC */
  var _foreignWriteTimer=null;
  document.addEventListener('nzs:cart-foreign-write',function(){
    if(!drawer.classList.contains('is-open')) return;
    clearTimeout(_foreignWriteTimer);
    _foreignWriteTimer=setTimeout(function(){
      _foreignWriteTimer=null;
      if(drawer.classList.contains('is-open')) fetchCart();
    },600);
  });
  itemsEl.addEventListener('click',function(e){
    var rb=e.target.closest('.nzs-cdr__retrybtn'); if(!rb) return;
    itemsEl.innerHTML='<div class="nzs-cdr__empty">Loading\u2026</div>';
    fetchCart();
  });
  /* NZS-CDR-DISC-0922: static controls, one transaction for apply/check/restore, no observers. */
  var codeBox=document.getElementById('nzsCdrCode'), codeInput=document.getElementById('nzsCdrCodeInput');
  var codeApplyBtn=document.getElementById('nzsCdrCodeApply'), codeRemoveBtn=document.getElementById('nzsCdrCodeRemove');
  var codeMsg=document.getElementById('nzsCdrCodeMsg'), _codeBusy=false, _codeUncertain=false, _codeSignature='', _serverSavings=0, _giftGate=false;
  function codeList(cart){ return ((cart&&cart.discount_codes)||[]).filter(function(c){ return c.applicable; }).map(function(c){ return String(c.code); }); }
  /* NZS-CDR-DISC-0922: Ajax order allocations wrap the application; amount is authoritative. */
  function codeOrderDiscount(cart){ return ((cart&&cart.cart_level_discount_applications)||[]).reduce(function(n,d){ return n+(Number(d.amount!=null?d.amount:d.total_allocated_amount!=null?d.total_allocated_amount:d.discount_application&&d.discount_application.total_allocated_amount)||0 /* NZS-CDR-FINISH-0923: /cart.js carries total_allocated_amount at the top level */); },0); }
  function codeSay(message,error){ if(codeMsg){ codeMsg.textContent=message; codeMsg.classList.toggle('is-error',!!error); } }
  /* NZS-CDR-PROMO-DISCLOSE-0922: presentation only, no persisted open state. */
  var codeToggle=document.getElementById('nzsCdrCodeToggle'), _codeVisualTimer=null;
  function codeDisclosure(open){ drawer.dispatchEvent(new CustomEvent('nzs:cdr-promo-disclosure',{detail:open})); }
  function codePaint(cart,options){
    /* NZS-CDR-DISC-0922: only a fresh server response resolves uncertainty, never cached RRP enrichment. */
    if(cart&&cart.token&&!(options&&options.cached)){
      if(_codeUncertain&&!_codeBusy) codeSay("Couldn't update the discount. Please try again.",true);
      _codeUncertain=false;
    }
    if(!codeBox) return;
    var codes=codeList(cart), signature=codes.join(',');
    var applied=document.getElementById('nzsCdrCodeApplied'), label=document.getElementById('nzsCdrCodeText');
    if(applied) applied.hidden=!codes.length;
    if(label) label.textContent=(codes.length>1?'Codes ':'Code ')+codes.join(', ')+' applied';
    if(!_codeBusy&&!_codeUncertain&&_codeSignature&&signature!==_codeSignature){
      codeSay(codes.length?'Your applied codes have changed.':'Your code no longer applies to these items.',false);
    }
    /* NZS-CDR-PROMO-DISCLOSE-0922: applied codes can still be expanded on subsequent paints. */
    if(codeToggle) codeToggle.textContent=codes.length?'Promo code applied':'Have a promo code?';
    if(signature&&signature!==_codeSignature) codeDisclosure(false);
    _codeSignature=signature;
  }
  function codeControls(on){
    _codeBusy=on;
    if(codeBox) codeBox.setAttribute('aria-busy',String(on));
    if(codeInput) codeInput.readOnly=on;
    /* NZS-CDR-BUSY-GRACE-0922: lock immediately, text changes only at request +1s. */
    clearTimeout(_codeVisualTimer);
    if(codeApplyBtn) codeApplyBtn.disabled=on; /* NZS-LOADER-0923-L3: label is a static .nzs-speed-label span now */
    if(codeRemoveBtn) codeRemoveBtn.disabled=on;
    if(!on&&window.__nzsLoadOff){ window.__nzsLoadOff(codeApplyBtn); window.__nzsLoadOff(codeRemoveBtn); } /* NZS-LOADER-0923-L3 */
  }
  function codePost(discount){
    return fetch(cartRoot+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({discount:discount}),__nzsCartGuardHandled:true})
      .then(function(r){ if(!r.ok) throw 0; return r.json(); })
      .then(function(c){ if(!c||!c.items||!c.token) throw 0; return c; });
  }
  function codeRead(){
    return fetch(cartRoot+'cart.js',{headers:{'Accept':'application/json'}})
      .then(function(r){ if(!r.ok) throw 0; return r.json(); })
      .then(function(c){ if(!c||!c.items||!c.token) throw 0; return c; });
  }
  function codeGiftLost(before,after){
    return (before.items||[]).some(function(it){
      if(String((it.properties||{})._nzs_gift||'').indexOf('tier-')!==0) return false;
      var other=(after.items||[]).filter(function(x){ return x.variant_id===it.variant_id&&(x.properties||{})._nzs_gift===it.properties._nzs_gift; })[0];
      // Line keys can change with discounts. Compare gift identity and per-unit server prices.
      return !other||other.final_line_price/other.quantity>it.final_line_price/it.quantity;
    });
  }
  function codeApply(value){
    if(_codeBusy||!currentCart||!currentCart.items||!currentCart.items.length) return;
    var focusWas=document.activeElement;
    codeControls(true); coGate(_giftGate); /* NZS-CDR-BUSY-GRACE-0922 */
    var codeHost=value?codeApplyBtn:codeRemoveBtn; /* NZS-LOADER-0923-L3: dots on the control that was pressed */
    queueCart(function(){
      if(codeHost&&window.__nzsLoadOn) window.__nzsLoadOn(codeHost); /* NZS-LOADER-0923-L3: shared dots (same 1s grace) replace the "Updating..." text swap; width stays fixed */
      _codeVisualTimer=setTimeout(function(){ if(_codeBusy) codeSay('Updating discount...',false); },1000); /* NZS-CDR-BUSY-GRACE-0922 */
      var seq=++_cartSeq, before=currentCart, previous=codeList(before).join(','), result=null, message='', failed=false, uncertainRecovery=false;
      function sameCodes(c,want){ return codeList(c).map(function(s){ return s.toUpperCase(); }).sort().join(',')===want.split(',').filter(Boolean).map(function(s){return s.toUpperCase();}).sort().join(','); }
      /* NZS-CDR-DISC-0922: retain genuine server truth even when the previous code cannot be restored. */
      function restoreState(c){
        result=c; _codeUncertain=false;
        if(!sameCodes(c,previous)) message='Your previous code no longer applies to these items.';
        else if(codeGiftLost(before,c)) message=previous?'That change would affect your gift reward. Your previous code has been kept.':'That code would affect your gift reward. It has not been applied.';
      }
      function restore(){
        return codePost(previous).catch(codeRead).then(restoreState);
      }
      return codePost(value).then(function(c){
        result=c; /* NZS-CDR-DISC-0922: this link has obtained a token-bearing server cart. */
        var hit=value?codeList(c).some(function(s){return s.toUpperCase()===value.toUpperCase();}):!codeList(c).length;
        var lost=codeGiftLost(before,c);
        if(!hit||lost){
          failed=true;
          message=lost?'That change would affect your gift reward. Your previous code has been kept.':"That code isn't valid for the items in your cart. Your previous code has been kept.";
          if(!previous) message=lost?'That code would affect your gift reward. It has not been applied.':"That code isn't valid for the items in your cart.";
          return restore();
        }
        result=c; _codeUncertain=false;
        message=value?'Discount applied.':'Discount removed.';
        if(codeInput) codeInput.value='';
        if(value) codeDisclosure(false); /* NZS-CDR-PROMO-DISCLOSE-0922: successful Apply collapses; Remove is already open. */
      }).catch(function(){
        failed=true;
        message="Couldn't update the discount. Your previous code has been kept. Please try again.";
        if(!previous) message="Couldn't update the discount. Please try again.";
        return restore().catch(function(){
          /* NZS-CDR-DISC-0922: uncertainty means no genuine cart was obtained in this link. */
          if(result) restoreState(result);
          else {
            _codeUncertain=true; uncertainRecovery=true;
            message="Couldn't confirm your discount. Refresh your cart before checkout.";
          }
        });
      }).then(function(){
        // Keep busy true while render repaints the code row, so status text is not overwritten.
        if(seq===_cartSeq&&result&&result.items&&result.token) render(result);
        else return fetchCart();
      }).finally(function(){
        codeControls(false);
        /* NZS-CDR-DISC-0922: trailing fetchCart may already have resolved uncertainty. */
        if(uncertainRecovery&&!_codeUncertain) message="Couldn't update the discount. Please try again.";
        codeSay(message,failed);
        // Preserve render's gift gate without rebuilding line DOM or stealing keyboard focus.
        coGate(_giftGate);
        /* NZS-CDR-PROMO-DISCLOSE-0922: never focus a control inside the inert collapsed panel. */
        if((focusWas===codeApplyBtn||focusWas===codeRemoveBtn)&&codeApplyBtn&&codeToggle&&codeToggle.getAttribute('aria-expanded')==='true'&&drawer.classList.contains('is-open')&&
          (document.activeElement===document.body||document.activeElement===focusWas)) codeApplyBtn.focus({preventScroll:true});
      });
    });
  }
  if(codeBox){
    codeBox.addEventListener('click',function(e){
      var hit=e.target.closest?e.target.closest('button'):e.target; /* NZS-LOADER-0923-L3: taps land on the label span */
      if(hit===codeApplyBtn){ var value=codeInput.value.trim(); if(value) codeApply(value); else { codeSay('Enter a promo code.',true); codeInput.focus(); } }
      if(hit===codeRemoveBtn) codeApply('');
    });
    codeInput.addEventListener('keydown',function(e){ if(e.key==='Enter'&&!e.isComposing){ e.preventDefault(); codeApplyBtn.click(); } });
    codeInput.addEventListener('input',function(){ if(!_codeBusy&&!_codeUncertain) codeSay('',false); });
    // Only observe the viewport while this input owns focus; no document observer or polling.
    function codeKeyboard(){
      if(document.activeElement!==codeInput||!drawer.classList.contains('is-open')) return;
      var v=window.visualViewport;
      drawer.classList.add('nzs-cdr__code-keyboard');
      if(v){ drawer.style.setProperty('--nzs-code-height',v.height+'px'); drawer.style.setProperty('--nzs-code-top',v.offsetTop+'px'); }
      codeInput.scrollIntoView({block:'nearest',behavior:'instant'});
    }
    codeInput.addEventListener('focus',function(){
      codeKeyboard();
      if(window.visualViewport){ visualViewport.addEventListener('resize',codeKeyboard); visualViewport.addEventListener('scroll',codeKeyboard); }
    });
    codeInput.addEventListener('blur',function(){
      if(window.visualViewport){ visualViewport.removeEventListener('resize',codeKeyboard); visualViewport.removeEventListener('scroll',codeKeyboard); }
      drawer.classList.remove('nzs-cdr__code-keyboard'); drawer.style.removeProperty('--nzs-code-height'); drawer.style.removeProperty('--nzs-code-top');
    });
  }

  /* ===== NZS-CDR-SUBUP: per-line "Subscribe & save 10%" ==============================
     Filter and default cadence are the PDP's (nzs-pdp-enhance.liquid), so a line converted here
     lands on the same plan the product page would have picked. Own delegated listener on
     [data-subup*] -- the [data-act] delegation above stays qty/remove only. */
  function subPlans(h){
    var out=[];
    (_plans[h]||[]).forEach(function(g){
      (g.selling_plans||[]).forEach(function(sp){
        var nm=String(sp.name||'').toLowerCase();
        if(nm.indexOf('week')<0 || nm.indexOf('10% discount')<0) return;   /* 15% is stack-only, never offered here */
        var wk=parseInt(String(sp.name).split(' ')[0].split('-')[0],10);
        if(!(wk>0)) return;
        out.push({w:wk,id:sp.id});
      });
    });
    out.sort(function(a,b){ return a.w-b.w; });
    return out;
  }
  /* Default the cadence to how long the tub lasts (1 serve/day => 7 a week): the largest plan week
     it covers, else the first >= 6 weeks, else the shortest. Same ladder as the PDP slider. */
  function subDefault(plans,title){
    var m=String(title||'').match(/(\d+)\s*serv/i), sv=m?parseInt(m[1],10):0, def=-1, i, j;
    if(sv>0){ var wkSup=Math.floor(sv/7); for(i=0;i<plans.length;i++){ if(plans[i].w<=wkSup) def=i; } }
    if(def<0){ for(j=0;j<plans.length;j++){ if(plans[j].w>=6){ def=j; break; } } }
    return def<0?0:def;
  }
  var _subBusy=false;
  function subLine(key){ return ((_lastCart&&_lastCart.items)||[]).filter(function(x){ return x.key===key; })[0]; }
  function subWks(n){ return n+' week'+(n===1?'':'s'); }
  /* Open state is read off the DOM, never cached: a full rebuild throws the panel away without
     telling us, and a stale "it's open" flag would make the next pill click a dead close. */
  function subPanelFor(key){
    var ps=itemsEl.querySelectorAll('.nzs-cdr__subpanel');
    for(var i=0;i<ps.length;i++){ if(ps[i].getAttribute('data-subup-panel')===key) return ps[i]; }
    return null;
  }
  function subClose(){
    itemsEl.querySelectorAll('.nzs-cdr__subpanel').forEach(function(p){ p.parentNode.removeChild(p); });
    itemsEl.querySelectorAll('[data-subup]').forEach(function(b){ b.setAttribute('aria-expanded','false'); });
  }
  function subShow(btn,key){
    var line=subLine(key); if(!line) return;
    var plans=subPlans(line.handle); if(!plans.length) return;
    subClose();                                       /* one panel at a time */
    var def=subDefault(plans,line.product_title), last=plans.length-1, pid='nzsSubp-'+key;
    var p=document.createElement('div');
    p.className='nzs-cdr__subpanel';
    p.id=pid;
    p.setAttribute('data-subup-panel',key);
    p.setAttribute('role','group');
    p.setAttribute('aria-label','Subscription frequency');
    p.innerHTML='<div class="nzs-cdr__subpanel-eye">Auto-ship</div>'
      +'<div class="nzs-cdr__subpanel-val" data-subup-val aria-live="polite">Every '+subWks(plans[def].w)+'</div>'
      +'<input type="range" class="nzs-cdr__subrange" data-subup-range="'+esc(key)+'" min="0" max="'+last+'" step="1" value="'+def+'" aria-label="Weeks between deliveries">'
      +'<div class="nzs-cdr__subpanel-ends"><span>'+plans[0].w+' wk'+(plans[0].w===1?'':'s')+'</span><span>'+plans[last].w+' wk'+(plans[last].w===1?'':'s')+'</span></div>'
      +'<div class="nzs-cdr__subpanel-act">'
      +'<button type="button" class="nzs-cdr__subok" data-subup-confirm="'+esc(key)+'"><span class="nzs-speed-label">Confirm</span></button>'
      +'<button type="button" class="nzs-cdr__subcancel" data-subup-cancel="'+esc(key)+'">Cancel</button></div>';
    btn.parentNode.insertBefore(p,btn.nextSibling);
    btn.setAttribute('aria-expanded','true');
    btn.setAttribute('aria-controls',pid);
  }
  function subPost(k,plan){
    return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({id:k,selling_plan:plan})})
      .then(function(r){ if(!r.ok) throw 0; return r.json(); });
  }
  /* A selling_plan change RE-KEYS the line, so the key on the button is only good for finding the
     variant. Bump _cartSeq first (the NZS-CDR-CLEAR guard) so any /cart.js already in flight is
     ignored, re-GET the cart, then match by variant_id -- the assets/nzs-stack-retier.js pattern.
     `want` disambiguates when the same variant sits in the cart twice, once one-time and once
     subscribed. Queued on chgChain so it can never interleave with a debounced qty write. The
     change response IS the new cart, so it goes straight to render(). */
  function subApply(key,plan,ctl){
    if(_subBusy) return;
    _subBusy=true;
    /* NZS-SPEED-LDR-SUBUP: shared dots plus a dimmed, aria-busy subscription panel. */
    var busyPanel=ctl&&ctl.closest('.nzs-cdr__subpanel');
    function subBusyOff(){ if(ctl){ if(window.__nzsLoadOff) window.__nzsLoadOff(ctl); ctl.disabled=false; } if(busyPanel){ busyPanel.classList.remove('is-busy'); busyPanel.removeAttribute('aria-busy'); } }
    if(ctl){ ctl.disabled=true; if(window.__nzsLoadOn) window.__nzsLoadOn(ctl); }
    if(busyPanel){ busyPanel.classList.add('is-busy'); busyPanel.setAttribute('aria-busy','true'); }
    var l0=subLine(key), vid=l0&&l0.variant_id, want=!plan;
    queueCart(function(){ /* NZS-CDR-DISC-0922: shared chain. */
      var seq=++_cartSeq;
      return fetch(cartRoot+'cart.js',{headers:{'Accept':'application/json'}})
        .then(function(r){ if(!r.ok) throw 0; return r.json(); })
        .then(function(c){
          var same=(c.items||[]).filter(function(x){ return x.variant_id===vid; });
          var line=same.filter(function(x){ return !!x.selling_plan_allocation===want; })[0]||same[0];
          if(!line) throw 0;                          /* gone (another tab / another surface) -> resync */
          /* Snapshot the OTHER subscribed keys for this variant so the undo retry below can never
             be aimed at one of them. Without this, un-subscribing line A of a variant the shopper
             also holds subscribed as line B could find B and silently convert it. */
          var preSub=same.filter(function(x){ return !!x.selling_plan_allocation; }).map(function(x){ return x.key; });
          /* NZS-CDR-SUBFIX: null is the documented clear and works here, but the old
             fallback was gated on the line's key having MOVED -- and a key only moves when the
             post actually did something, so the retry could never fire in the one case it existed
             for. Escalate instead: null -> '' -> remove + re-add one-time. Each step is tolerant,
             so a rejected retry falls through to the next rather than killing the chain. */
          function stillSub(c){ return ((c&&c.items)||[]).filter(function(x){ return x.variant_id===vid && x.selling_plan_allocation; }); }
          function tryPost(k,p,fallbackCart){ return subPost(k,p).catch(function(){ return fallbackCart; }); }
          return subPost(line.key,plan).then(function(c2){
            if(plan) return c2;
            var s2=stillSub(c2);
            if(s2.length<preSub.length) return c2;   /* a subscribed line went away -> null worked */
            /* prefer the line we just posted (its key moved), else the original key, which is
               exactly what a silent no-op leaves behind */
            var t2=s2.filter(function(x){ return preSub.indexOf(x.key)<0; })[0]
                 || s2.filter(function(x){ return x.key===line.key; })[0] || s2[0];
            if(!t2) return c2;
            return tryPost(t2.key,'',c2).then(function(c3){
              var s3=stillSub(c3);
              if(s3.length<preSub.length) return c3;
              /* Last resort: the allocation will not clear in place, so drop the line and re-add
                 the variant one-time. Quantity and properties are carried over; the line moves to
                 the end of the cart, which is the acceptable cost of it actually working. */
              var t3=s3.filter(function(x){ return x.key===t2.key; })[0]||s3[0];
              if(!t3) return c3;
              return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
                body:JSON.stringify({id:t3.key,quantity:0})})
                .then(function(r){ if(!r.ok) throw 0; return r.json(); })
                .then(function(){
                  if(!window.nzsATC) throw new Error("Couldn't add to cart");
                  return window.nzsATC.add(
                    {items:[{id:t3.variant_id,quantity:t3.quantity,properties:t3.properties||{}}]},
                    {handle:t3.handle}
                  );
                })
                .then(function(){ return fetch(cartRoot+'cart.js',{headers:{'Accept':'application/json'}}); })
                .then(function(r){ if(!r.ok) throw 0; return r.json(); })
                .catch(function(){ return c3; });
            });
          });
        })
        .then(function(c3){
          _subBusy=false;
          subBusyOff();
          /* NZS-CDR-SUBFIX: a newer /cart.js read won the race. The old code returned here,
             which left the drawer painted with the PRE-toggle rows -- indistinguishable from
             "the toggle did nothing". Re-sync so the UI always ends on the truth. */
          if(seq!==_cartSeq){ fetchCart(); return; }
          if(c3&&c3.items&&c3.token) render(c3); else fetchCart();
        })
        .catch(function(){ _subBusy=false; subBusyOff(); fetchCart(); });
    });
  }
  itemsEl.addEventListener('click',function(e){
    var t=e.target; if(!t||!t.closest) return;
    var b=t.closest('[data-subup]');
    if(b){ e.preventDefault(); var bk=b.getAttribute('data-subup');
      if(subPanelFor(bk)) subClose(); else subShow(b,bk); return; }
    var c=t.closest('[data-subup-cancel]');
    if(c){ e.preventDefault(); subClose(); return; }
    var ok=t.closest('[data-subup-confirm]');
    if(ok){ e.preventDefault();
      var key=ok.getAttribute('data-subup-confirm'), line=subLine(key), plans=line?subPlans(line.handle):[];
      var panel=ok.closest('.nzs-cdr__subpanel'), rg=panel&&panel.querySelector('[data-subup-range]');
      var i=rg?Math.max(0,Math.min(plans.length-1,parseInt(rg.value,10)||0)):0;
      if(plans[i]) subApply(key,plans[i].id,ok);
      return; }
    var u=t.closest('[data-subup-undo]');
    if(u){ e.preventDefault(); subApply(u.getAttribute('data-subup-undo'),null,u); return; }
  });
  itemsEl.addEventListener('input',function(e){
    var t=e.target; if(!t||!t.closest) return;
    var rg=t.closest('[data-subup-range]'); if(!rg) return;
    var line=subLine(rg.getAttribute('data-subup-range')), plans=line?subPlans(line.handle):[];
    if(!plans.length) return;
    var i=Math.max(0,Math.min(plans.length-1,parseInt(rg.value,10)||0));
    var panel=rg.closest('.nzs-cdr__subpanel'), v=panel&&panel.querySelector('[data-subup-val]');
    if(v) v.textContent='Every '+subWks(plans[i].w);
  });
  var cartOverlay = null;
  /* ===== NZS-CDR-TABS ============================================================
     Pane switching is attribute-driven (aria-selected + hidden/inert) with a roving tabindex.
     The RV pane is filled from sections/nzs-cdr-rv.liquid through the Section Rendering API;
     localStorage is re-read on every activation because the `storage` event does not fire in
     the tab that wrote it, so a PDP viewed in THIS tab would otherwise never show up. */
  var rvPane=document.getElementById('nzsCdrPaneRv'), rvBox=document.getElementById('nzsCdrRv');
  var tabCart=document.getElementById('nzsCdrTabCart'), tabRv=document.getElementById('nzsCdrTabRv');
  var tabOffers=document.getElementById('nzsCdrTabOffers'), offersPane=document.getElementById('nzsCdrPaneOffers'), offersBox=document.getElementById('nzsCdrOffers');   /* NZS-OFFERS-0820 */
  var rvSeq=0, rvAbort=null, rvLoadedFor='';
  function rvIds(){
    var raw='[]', list=[];
    try{ raw=localStorage.getItem('recently-viewed')||'[]'; }catch(_){}
    try{ list=JSON.parse(raw); }catch(_){ list=[]; }
    if(!list||typeof list.length!=='number') list=[];
    var out=[], seen={};
    for(var i=0;i<list.length&&out.length<8;i++){
      var id=String(list[i]);
      if(!/^[0-9]+$/.test(id)||seen[id]) continue;
      seen[id]=1; out.push(id);
    }
    return out;
  }
  function rvLoad(){
    if(!rvBox) return;
    var ids=rvIds(), sig=ids.join(',');
    if(sig===rvLoadedFor&&rvBox.children.length) return;   /* already showing exactly this list */
    var seq=++rvSeq;
    if(rvAbort){ try{ rvAbort.abort(); }catch(_){} }
    rvAbort=(typeof AbortController==='function')?new AbortController():null;
    if(!rvBox.children.length) rvBox.innerHTML='<div class="nzs-cdr__rv-msg">Loading\u2026</div>';
    /* no history: ask for an id that cannot match, and the section falls through to best-sellers */
    var q=ids.length?ids.map(function(i){ return 'id:'+i; }).join(' OR '):'id:0';
    var url=(window.Shopify&&Shopify.routes&&Shopify.routes.root?Shopify.routes.root:'/')+'search?section_id=nzs-cdr-rv&type=product&q='+encodeURIComponent(q);
    fetch(url,rvAbort?{signal:rvAbort.signal}:undefined)
      .then(function(r){ if(!r.ok) throw 0; return r.text(); })
      .then(function(html){
        if(seq!==rvSeq) return;                            /* a newer activation won */
        var doc=new DOMParser().parseFromString(html,'text/html');
        var box=doc.querySelector('[data-cdr-rv-mode]');
        /* a Shopify error page answers 200 with no section in it -- treat that as a failure */
        if(!box||!box.children.length){ rvBox.innerHTML='<div class="nzs-cdr__rv-msg">Nothing here yet</div>'; rvLoadedFor=''; return; }
        var head=box.getAttribute('data-cdr-rv-mode')==='fallback'?'<div class="nzs-cdr__rv-msg">Popular right now</div>':'';
        rvBox.innerHTML=head+box.innerHTML;
        rvLoadedFor=sig;
      })
      .catch(function(){
        if(seq!==rvSeq) return;
        rvBox.innerHTML='<div class="nzs-cdr__rv-msg">Nothing here yet</div>'; rvLoadedFor='';
      });
  }
  /* NZS-OFFERS-0820: generic 3-tab switcher (Cart | Offers | Recently Viewed). Filters out
     absent elements so a template without the Offers pane degrades to the old two-tab drawer. */
  function selectTab(name,opts){
    if(!tabCart) return;
    var reg=[
      {n:'cart',tab:tabCart,pane:document.getElementById('nzsCdrPaneCart')},
      {n:'offers',tab:tabOffers,pane:offersPane},
      {n:'rv',tab:tabRv,pane:rvPane}
    ].filter(function(r){ return r.tab&&r.pane; });
    var cur=null;
    reg.forEach(function(r){
      var on=r.n===name; if(on) cur=r;
      r.tab.setAttribute('aria-selected',on?'true':'false');
      r.tab.classList.toggle('is-on',on);
      r.tab.tabIndex=on?0:-1;
      r.pane.hidden=!on; if('inert' in r.pane) r.pane.inert=!on;
    });
    if(!cur) return;
    if(name==='rv') rvLoad();
    if(name==='offers'){ renderOffers(); croEv('offers_tab_viewed'); }
    if(opts&&opts.focus) cur.tab.focus();
  }
  var TAB_ORDER=[{n:'cart',t:tabCart},{n:'offers',t:tabOffers},{n:'rv',t:tabRv}].filter(function(x){ return x.t; });
  TAB_ORDER.forEach(function(x,i){
    x.t.addEventListener('click',function(){ selectTab(x.n,{focus:false}); });
    x.t.addEventListener('keydown',function(e){
      if(e.key!=='ArrowLeft'&&e.key!=='ArrowRight') return;
      e.preventDefault();
      var j=(i+(e.key==='ArrowRight'?1:TAB_ORDER.length-1))%TAB_ORDER.length;
      selectTab(TAB_ORDER[j].n,{focus:true});
    });
  });
  /* the RV pane's Add buttons are .nzs-cdr__rec-add, the same contract the recs row uses, but
     that delegate is bound to #nzsCdrRecsRow -- bind the twin here. */
  if(rvBox) rvBox.addEventListener('click',function(e){
    var btn=e.target.closest('[data-rec-add]'); if(!btn||btn.disabled) return;
    var vid=parseInt(btn.dataset.recAdd,10); if(!vid) return;
    btn.disabled=true; /* NZS-LOADER-0923-L2: a second tap inside the 1s grace no longer adds twice */
    if(window.__nzsLoadOn) window.__nzsLoadOn(btn);
    var add=window.nzsATC?window.nzsATC.add({items:[{id:vid,quantity:1}]},{}):Promise.reject(new Error('Please try again'));
    add.then(function(){ if(window.__nzsLoadOff) window.__nzsLoadOff(btn); btn.disabled=false; /* NZS-LOADER-0923-L2 */ recsKey=''; /* NZS-CDR-SPEED-0922: RV uses the confirmed add cart. */ selectTab('cart',{focus:false}); })
       .catch(function(){ if(window.__nzsLoadOff) window.__nzsLoadOff(btn); btn.disabled=false; /* NZS-LOADER-0923-L2 */ });
  });
  /* ===== NZS-OFFERS-0820 r3: Offers pane + schema-driven multi-tier gifts + review stars ====
     Entitlement types (from config, no product-specific branches):
       single       — one product, one tap
       flavour_pick — one product family, inline flavour list (split-product store: flavours ARE
                      sibling products)
       multi_pick   — choose N from a pool (optional duplicates), count UI
       random_pool  — N random distinct in-stock items from the pool
       'flat' is flattened into singles at Liquid render.
     Pricing authority = the automatic "NZS Reward" BXGY discounts; lines carry
     properties._nzs_gift='tier-<amt-cents>' for tracking/locking/housekeeping only. */
  function croEv(ev,d){ try{ document.dispatchEvent(new CustomEvent('nzs:cro',{detail:Object.assign({ev:ev},d||{})})); }catch(_e){} }
  function moneyShort(c){ return c%100===0?('$'+(c/100)):money(c); }
  function tierProp(t){ return 'tier-'+t.amt; }
  function tierLines(cart,t){
    var p=tierProp(t);
    return ((cart&&cart.items)||[]).filter(function(it){ return (it.properties||{})._nzs_gift===p; });
  }
  /* qualifying total: paid items only — an UNEARNED gift line (discount not applying) must not
     count toward unlocking its own tier. Earned gift lines are $0 so subtracting is a no-op. */
  /* NZS-CDR-QUAL-0923 (owner, verified live with /cart.js 23 Sep): two qualifying totals, both on money actually paid.
     ship = free-shipping tier: final_line_price of every non-gift line, minus the WHOLE order-level discount
            (sum of every line's final minus cart.total_price), so never above total_price minus the gift lines.
     gift = every gift tier: the "NZS Reward" BXGY discounts (customerBuys: shop-all, excluding tag singles-only) do
            not count a line that carries any other product discount (Kaching bundles, stack %, line codes). So only
            non-gift lines with no line-level allocation other than "NZS Reward" count; the
            order discount is NOT taken off (see below). singles-only tags are not in /cart.js, so those lines still count here (known gap).
     Gift lines (_nzs_gift / _Free) never qualify themselves, so a gift's own discount changing never moves either
     total (no drop-below oscillation). bundle = some paid line is excluded from the gift total. */
  var NZS_REWARD_DISC=/^\s*NZS Reward/i;
  function nzsDiscTitle(d){ return String((d&&((d.discount_application&&d.discount_application.title)||d.title))||''); }
  /* Product-level allocations ONLY: items[].discounts also lists the ORDER code on every line (live /cart.js, 23 Sep),
     which would make every line look bundle-discounted whenever a code is applied. */
  function nzsLineOtherDisc(it){ return (it.line_level_discount_allocations||[]).some(function(d){ return !NZS_REWARD_DISC.test(nzsDiscTitle(d)); }); }
  function nzsLineRewardDisc(it){ return (it.line_level_discount_allocations||[]).some(function(d){ return NZS_REWARD_DISC.test(nzsDiscTitle(d)); }); }
  function nzsQual(cart){
    var items=(cart&&cart.items)||[], paid=0, giftPaid=0, all=0;
    items.forEach(function(it){
      var p=it.properties||{}, f=Number(it.final_line_price);
      if(!isFinite(f)) f=Number(it.original_line_price)||0;
      all+=f; if(p._nzs_gift||p._Free) return;
      paid+=f; if(!nzsLineOtherDisc(it)) giftPaid+=f;
    });
    var tp=cart&&cart.total_price!=null?Number(cart.total_price):NaN, order=isFinite(tp)?Math.max(0,all-tp):0;
    /* ship: after the order discount (conservative). gift: BEFORE it, because Shopify applies product discounts (incl. the
       BXGY reward) before order codes and judges the reward prerequisite first (verified: gift stays free after tomstar10). */
    return {ship:Math.round(Math.max(0,paid-order)),gift:Math.round(giftPaid),bundle:giftPaid<paid};
  }
  function qualTotal(cart){ return nzsQual(cart).ship; } /* NZS-CDR-QUAL-0923: free-shipping qualifying total */
  function giftQual(cart){ return nzsQual(cart).gift; } /* NZS-CDR-QUAL-0923: gift-tier qualifying total */
  function tierQual(cart,t){ return t&&t.icon==='truck'?qualTotal(cart):giftQual(cart); } /* the right total for a tier */
  /* NZS-DRINKSHIP-1007 BEGIN (Blake 2026-10-07): free shipping does not apply when the cart holds MORE than 4 energy drinks
     (product tag type:energy-rtd; drinks per line = qty x custom.drink_units). Checkout is enforced by Functions; this is
     UI only. Units come from the nzs-cdr-lines payload already fetched at open (no extra request); the /products/<h>.js
     fallback has tags but no metafields, so it reads the "12-Pack" / "24-Pack" title (else 1). Unknown products count 0. */
  function drinkGuess(p){ var tags=(p&&p.tags)||[]; if(typeof tags==='string') tags=tags.split(/,\s*/); if(tags.indexOf('type:energy-rtd')<0) return 0; var m=/(\d+)\s*-?\s*pack/i.exec(p.title||''); return m?Number(m[1]):1; }
  function drinkCount(cart){ var n=0; ((cart&&cart.items)||[]).forEach(function(it){ var e=_linesMemo[it.product_id], u=e?Number(e.drinks):0; if(u>0) n+=u*(Number(it.quantity)||0); }); return n; }
  function shipBlocked(cart){ return drinkCount(cart)>4; }
  function drinkMsg(){ return 'Orders with <b>5+ energy drinks</b> don\u2019t ship free.'; }
  function tierOk(cart,t){ return !!t&&tierQual(cart,t)>=t.amt&&!(t.icon==='truck'&&shipBlocked(cart)); } /* reached, drink rule applied */
  var _drinkBl=false; /* start unblocked: carts with <=4 drinks never repaint */
  function drinkResync(){ /* units can land after the first paint (lines race / fallback): repaint the reward only when the rule flips */
    var c=currentCart; if(!c||!c.items) return;
    var b=shipBlocked(c); if(b===_drinkBl) return; _drinkBl=b;
    updateReward(Object.keys(pending).length?projectedCart(c):c);
  }
  /* NZS-DRINKSHIP-1007 END */
  /* A tier gift line the server did NOT discount (no "NZS Reward" allocation, still charged): not a gift yet. */
  function nzsGiftNotFree(it){ var p=it.properties||{}; return !!p._nzs_gift&&Number(it.final_line_price)>0&&!nzsLineRewardDisc(it); }
  function nzsGiftLocked(it,pp){ var p=it.properties||{}; return (!!p._nzs_gift&&!nzsGiftNotFree(it))||pp.free===true; }
  function optAvail(o){
    var av=(o.items||[]).filter(function(g){ return g.av!==false; });
    if(o.type==='multi_pick'&&!o.dup&&av.length<(o.qty|0)) return [];
    if(o.type==='random_pool'&&av.length<1) return [];
    return av;
  }
  var CHECK_IMG='<img src="'+esc((window.__nzsCdrCfg&&window.__nzsCdrCfg.check)||'')+'" alt="" width="15" height="15" loading="lazy">';
  var CHECK_IMG22='<img src="'+esc((window.__nzsCdrCfg&&window.__nzsCdrCfg.check)||'')+'" alt="" width="22" height="22" loading="lazy">';   /* NZS-OFFERS-0820 r8 */
  function renderOffers(){
    if(!offersBox) return;
    var cart=currentCart||{items:[],total_price:0};
    offersBox.innerHTML=REWARDS.map(function(t,ti){
      var tq=tierQual(cart,t), un=tierOk(cart,t), isGift=!!(t.opts&&t.opts.length); /* NZS-CDR-QUAL-0923 */
      var head='<span class="nzs-cdr__offer-ic">'+(rwIcon(t.icon)||rwIcon('gift'))+'</span>';
      var name='<div class="nzs-cdr__offer-name">'+esc(t.label)+' at '+moneyShort(t.amt)+'</div>'; /* NZS-UPSELL-0911: ponytail: edit the existing hook instead of a second implementation. */
      var body, act='';
      if(!isGift){
        body=(t.icon==='truck'&&shipBlocked(cart))?'<div class="nzs-cdr__offer-sub">'+drinkMsg()+'</div>' /* NZS-DRINKSHIP-1007 */
          :un?'<span class="nzs-cdr__offer-state">'+CHECK_IMG+' Unlocked</span>'
               :'<div class="nzs-cdr__offer-sub">Add <b>'+money(t.amt-tq)+'</b> more for <b>'+esc(t.label)+'</b></div>'; /* NZS-UPSELL-0911: ponytail: edit the existing hook instead of a second implementation. */
      } else {
        var lines=tierLines(cart,t);
        var live=t.opts.filter(function(o){ return optAvail(o).length; });
        var thumbs='';
        if(!lines.length){
          /* NZS-OFFERS-0820 r6: every live option contributes its first image FIRST (so a
             one-option-per-family reward like the Macro Mike pack is always represented),
             then remaining flavours fill up to 6. */
          var seen={}, imgs=[];
          function takeImg(g){ if(g&&g.av!==false&&g.img&&!seen[g.img]&&imgs.length<6){ seen[g.img]=1; imgs.push(g.img); } }
          live.forEach(function(o){ takeImg(optAvail(o)[0]); });
          live.forEach(function(o){ (o.items||[]).forEach(takeImg); });
          thumbs=imgs.length?'<div class="nzs-cdr__offer-thumbs">'+imgs.map(function(u){ return '<img src="'+esc(u)+'" alt="" loading="lazy" width="40" height="40">'; }).join('')+'</div>':'';
        }
        if(lines.length){
          var names=lines.map(function(l){ return esc(l.product_title||l.title||''); });
          var label=names.slice(0,2).join(', ')+(names.length>2?' +'+(names.length-2):'');
          body='<span class="nzs-cdr__offer-state">'+CHECK_IMG+' Added: '+label+'</span>'; /* NZS-UPSELL-0911: ponytail: edit the existing hook instead of a second implementation. */
          act='<button type="button" class="nzs-cdr__offer-pick nzs-cdr__offer-pick--view" data-offer-pick="'+t.amt+'">Change selection</button>';
        } else if(un){
          if(!live.length){ body='<div class="nzs-cdr__offer-sub">Gift options are out of stock right now. Back soon.</div>'; } /* NZS-UPSELL-0911: ponytail: edit the existing hook instead of a second implementation. */
          else {
            body=thumbs+'<div class="nzs-cdr__offer-sub">Unlocked: <b>'+esc(t.label)+'</b>'+(t.desc?'. '+esc(t.desc):'')+'</div>'; /* NZS-UPSELL-0911: ponytail: edit the existing hook instead of a second implementation. */
            act='<button type="button" class="nzs-cdr__offer-pick" data-offer-pick="'+t.amt+'">Select gift</button>';
          }
        } else {
          body=thumbs+'<div class="nzs-cdr__offer-sub">Add <b>'+money(t.amt-tq)+'</b> more for <b>'+esc(t.label)+'</b></div>'; /* NZS-UPSELL-0911: ponytail: edit the existing hook instead of a second implementation. */
          if(live.length) act='<button type="button" class="nzs-cdr__offer-pick nzs-cdr__offer-pick--view" data-offer-view="'+t.amt+'">View gifts</button>';
        }
      }
      return '<div class="nzs-cdr__offer '+(un?'is-unlocked':'is-locked')+'" style="--gm-i:'+ti+'"><div class="nzs-cdr__offer-main">'+head+'<div class="nzs-cdr__offer-body">'+name+body+'</div><div class="nzs-cdr__offer-act">'+act+'</div></div></div>';
    }).join('');
  }
  if(offersBox) offersBox.addEventListener('click',function(e){
    var b=e.target.closest('[data-offer-pick],[data-offer-view]'); if(!b) return;
    var view=b.hasAttribute('data-offer-view');
    var amt=parseInt(b.getAttribute(view?'data-offer-view':'data-offer-pick'),10), t=null;
    REWARDS.forEach(function(r){ if(r.amt===amt&&r.opts&&r.opts.length) t=r; });
    if(t){ croEv('gift_selector_opened',{amt:amt,view:view}); gmOpen([t],view); }
  });
  /* --- gift-selection modal --- */
  /* NZS-OFFERS-0820-R4-GMDIV: option/sub cards are role=radio DIVS - nested <button>s are
     invalid HTML and get ejected by the parser. Inner qty steppers stay real buttons. */
  var gmEl=document.getElementById('nzsCdrGm');
  var gmQueue=[], gmIdx=0, gmBusyFlag=false, gmLastFocus=null, gmViewOnly=false;
  var gmOpt=null, gmPicks={};                       /* selected option + {vid:qty} */
  function gmPickCount(){ var n=0; Object.keys(gmPicks).forEach(function(k){ n+=gmPicks[k]; }); return n; }
  function gmValid(){
    if(!gmOpt) return false;
    if(gmOpt.type==='random_pool') return true;
    return gmPickCount()===(gmOpt.qty|0||1);
  }
  function gmSyncUi(){
    var ok=document.getElementById('nzsCdrGmOk'), cnt=document.getElementById('nzsCdrGmCount');
    if(ok) ok.disabled=gmViewOnly||!gmValid()||gmBusyFlag;
    if(cnt){
      if(gmOpt&&gmOpt.type==='multi_pick'){ cnt.hidden=false; cnt.textContent=gmPickCount()+' of '+gmOpt.qty+' selected'; }
      else cnt.hidden=true;
    }
  }
  function gmSubList(o){
    var av=optAvail(o), dup=!!o.dup, isMulti=o.type==='multi_pick';
    return '<span class="nzs-cdr-gm__opt-sub" role="group" aria-label="'+(isMulti?'Choose '+o.qty:'Choose flavour')+'">'+ (o.items||[]).map(function(g,sgi){
      var out=g.av===false;
      var qtyUi=(isMulti&&dup&&!out)?'<span class="nzs-cdr-gm__sopt-qty"><button type="button" data-gm-minus="'+g.vid+'" aria-label="Fewer '+esc(g.t)+'">\u2212</button><b data-gm-n="'+g.vid+'">0</b><button type="button" data-gm-plus="'+g.vid+'" aria-label="More '+esc(g.t)+'">+</button></span>':'';
      return '<div class="nzs-cdr-gm__sopt'+(out?' is-out':'')+'" role="radio" style="--gm-i:'+sgi+'" aria-checked="false" data-gm-sub="'+g.vid+'" tabindex="'+(out?'-1':'0')+'"'+(out?' aria-disabled="true"':'')+'><img src="'+esc(g.img)+'" alt="" loading="lazy" width="34" height="34"><span class="nzs-cdr-gm__sopt-name">'+esc(g.t)+(out?' (sold out)':'')+'</span>'+(qtyUi||('<span class="nzs-cdr-gm__sopt-check" aria-hidden="true">'+CHECK_IMG22+'</span>'))+'</div>'; /* NZS-UPSELL-0911: ponytail: edit the existing hook instead of a second implementation. */
    }).join('')+'</span>';
  }
  function gmRenderStep(){
    var t=gmQueue[gmIdx]; if(!t||!gmEl) return;
    var title=document.getElementById('nzsCdrGmTitle'), step=document.getElementById('nzsCdrGmStep');
    var list=document.getElementById('nzsCdrGmList'), err=document.getElementById('nzsCdrGmErr');
    if(gmViewOnly){
      title.textContent=t.label||'Free gift';
      step.hidden=false;
      var _need=Math.max(0,t.amt-tierQual(currentCart||{},t)); /* NZS-CDR-QUAL-0923 */
      step.innerHTML='Add <b>'+money(_need)+'</b> more to unlock';
    } else {
      title.textContent=gmQueue.length>1?(gmQueue.length+' free gifts unlocked'):(t.label||'Free gift')+' unlocked';
      step.hidden=false;
      step.innerHTML='Choose your free gift'+(gmQueue.length>1?'s':'')+' <b>'+(gmIdx+1)+'/'+gmQueue.length+'</b>';
    }
    gmOpt=null; gmPicks={}; if(err) err.hidden=true;
    var live=t.opts.filter(function(o){ return optAvail(o).length; });
    list.innerHTML=live.map(function(o,gmi){
      var av=optAvail(o);
      var img=av[0]?av[0].img:(o.items&&o.items[0]?o.items[0].img:'');
      /* NZS-OFFERS-0820 r9 (Blake): ALWAYS strike a compare-at — the most expensive available
         item in the pool; Choose-N/random pools sum the top-N (dup pools: max x N). */
      var caps=av.map(function(g){ return Math.max(g.cap||0,g.p||0); }).sort(function(a,b){ return b-a; });
      var q=Math.max(1,o.qty|0), capC=0;
      if(q===1) capC=caps[0]||0;
      else if(o.dup) capC=(caps[0]||0)*q;
      else { for(var ci=0;ci<q&&ci<caps.length;ci++) capC+=caps[ci]; }
      var priceRow;
      var pctFree=(o.pct|0)>=100;
      if(pctFree) priceRow=(capC>0?'<s>'+money(capC)+'</s>':'')+'<span class="nzs-cdr-gm__opt-free">Free</span>';
      else priceRow=(capC>0?'<s>'+money(capC)+'</s>':'')+'<span class="nzs-cdr-gm__opt-pct">'+(o.pct|0)+'% OFF</span>';
      var hint='';
      if(o.type==='flavour_pick') hint=': choose flavour'; /* NZS-UPSELL-0911: ponytail: edit the existing hook instead of a second implementation. */
      if(o.type==='multi_pick') hint=': choose '+o.qty; /* NZS-UPSELL-0911: ponytail: edit the existing hook instead of a second implementation. */
      if(o.type==='random_pool') hint=': '+o.qty+' random'; /* NZS-UPSELL-0911: ponytail: edit the existing hook instead of a second implementation. */
      return '<div class="nzs-cdr-gm__opt" role="radio" tabindex="0" aria-checked="false" style="--gm-i:'+gmi+'" data-gm-opt="'+esc(o.k)+'">'
        +'<img src="'+esc(img)+'" alt="" loading="lazy" width="52" height="52">'
        +'<span class="nzs-cdr-gm__opt-body"><span class="nzs-cdr-gm__opt-name">'+esc(o.label)+'<span style="font-weight:600;color:var(--ink-500,#6b7280)">'+hint+'</span></span>'
        +'<span class="nzs-cdr-gm__opt-price">'+priceRow+'</span></span>'
        +'<span class="nzs-cdr-gm__opt-check" aria-hidden="true">'+CHECK_IMG22+'</span>'
        +(o.type==='flavour_pick'||o.type==='multi_pick'?gmSubList(o):'')
        +'</div>';
    }).join('')||'<div class="nzs-cdr__rv-msg">Nothing available right now</div>';
    gmSyncUi();
  }
  function gmOpen(queue,viewOnly){
    if(!gmEl||!queue||!queue.length) return;
    gmQueue=queue; gmIdx=0; gmBusyFlag=false; gmViewOnly=!!viewOnly; gmLastFocus=document.activeElement;
    gmRenderStep();
    gmEl.hidden=false; gmEl.setAttribute('aria-hidden','false');
    void gmEl.offsetWidth;   /* forced reflow, never rAF (occluded windows starve rAF) */
    gmEl.classList.add('is-in');
    var box=gmEl.querySelector('.nzs-cdr-gm__box');
    if(box){ box.setAttribute('tabindex','-1'); box.focus({preventScroll:true}); }
  }
  function gmClose(){
    if(!gmEl||gmEl.hidden) return;
    gmEl.classList.remove('is-in');
    gmEl.setAttribute('aria-hidden','true');
    gmEl.hidden=true;
    gmBusyFlag=false;
    if(gmLastFocus&&gmLastFocus.focus){ try{ gmLastFocus.focus({preventScroll:true}); }catch(_e){} }
  }
  function gmFind(t,k){ var f=null; (t.opts||[]).forEach(function(o){ if(o.k===k) f=o; }); return f; }
  function gmConfirm(){
    var t=gmQueue[gmIdx]; if(gmViewOnly||!t||!gmOpt||gmBusyFlag||!gmValid()) return;
    var ok=document.getElementById('nzsCdrGmOk'), errEl=document.getElementById('nzsCdrGmErr');
    var picks=gmPicks;
    if(gmOpt.type==='random_pool'){
      /* N random DISTINCT in-stock samples from the configured pool */
      var av=optAvail(gmOpt).slice();
      for(var i=av.length-1;i>0;i--){ var j=Math.floor(Math.random()*(i+1)); var tmp=av[i]; av[i]=av[j]; av[j]=tmp; }
      picks={}; av.slice(0,Math.max(1,gmOpt.qty|0)).forEach(function(g){ picks[g.vid]=1; });
    }
    var items=Object.keys(picks).filter(function(v){ return picks[v]>0; }).map(function(v){
      return {id:parseInt(v,10),quantity:picks[v],properties:{_nzs_gift:tierProp(t)}};
    });
    if(!items.length) return;
    gmBusyFlag=true; gmSyncUi(); if(window.__nzsLoadOn) window.__nzsLoadOn(ok);
    /* NZS-OFFERS-0820 r11: "Change selection" — a re-pick replaces the previous gift lines
       for this tier (serial removes, then the batched add). First-time picks have none. */
    /* NZS-CDR-DISC-0922: gift replacement cannot interleave with code apply/revert. */
    var add=queueCart(function(){
    ++_cartSeq;
    var oldLines=tierLines(currentCart||{},t);
    var pre=oldLines.reduce(function(p,l){
      return p.then(function(){ return fetch(cartRoot+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:l.key,quantity:0}),__nzsCartGuardHandled:true}).catch(function(){}); });
    },Promise.resolve());
    /* NZS-CDR-SPEED-0922: consume only this gift add's confirmed cart inside its own link. */
    return pre.then(function(){
      _giftAddInLink={};
      return window.nzsATC?window.nzsATC.add({items:items},{cdrLink:_giftAddInLink}):Promise.reject(new Error('Please try again'));
    }).finally(function(){ _giftAddInLink=null; });
    }); /* NZS-CDR-DISC-0922 */
    add.then(function(){
      gmBusyFlag=false; if(window.__nzsLoadOff) window.__nzsLoadOff(ok);
      croEv('gift_selected',{amt:t.amt,opt:gmOpt.k});
      recsKey=''; /* NZS-CDR-SPEED-0922: confirmed-add hook supplies the cart once. */
      if(gmIdx<gmQueue.length-1){
        gmIdx++;
        var list=document.getElementById('nzsCdrGmList');
        list.classList.add('is-swap');
        setTimeout(function(){ gmRenderStep(); list.classList.remove('is-swap'); },180);
      } else gmClose();
    }).catch(function(err){
      gmBusyFlag=false; if(window.__nzsLoadOff) window.__nzsLoadOff(ok);
      gmSyncUi();
      if(errEl){ errEl.textContent=(err&&err.message)||"Couldn't add that gift. Try another option"; errEl.hidden=false; } /* NZS-UPSELL-0911: ponytail: edit the existing hook instead of a second implementation. */
    });
  }
  if(gmEl){
    gmEl.addEventListener('click',function(e){
      if(e.target.closest('[data-gm-cancel]')){ gmClose(); return; }
      var t=gmQueue[gmIdx]; if(!t) { if(e.target.closest('#nzsCdrGmOk')) gmConfirm(); return; }
      var plus=e.target.closest('[data-gm-plus]'), minus=e.target.closest('[data-gm-minus]');
      var sub=e.target.closest('[data-gm-sub]');
      var optBtn=e.target.closest('[data-gm-opt]');
      if(plus||minus){
        e.stopPropagation();
        var vid=(plus||minus).getAttribute(plus?'data-gm-plus':'data-gm-minus');
        if(gmOpt&&gmOpt.type==='multi_pick'){
          var cur=gmPicks[vid]||0, tot=gmPickCount();
          if(plus&&tot<(gmOpt.qty|0)) gmPicks[vid]=cur+1;
          if(minus&&cur>0){ gmPicks[vid]=cur-1; if(!gmPicks[vid]) delete gmPicks[vid]; }
          var nEl=gmEl.querySelector('[data-gm-n="'+vid+'"]'); if(nEl) nEl.textContent=gmPicks[vid]||0;
          var host=gmEl.querySelector('[data-gm-sub="'+vid+'"]'); if(host) host.setAttribute('aria-checked',(gmPicks[vid]||0)>0?'true':'false');
          gmSyncUi();
        }
        return;
      }
      if(sub&&!sub.classList.contains('is-out')&&gmOpt){
        var vid2=sub.getAttribute('data-gm-sub');
        if(gmOpt.type==='flavour_pick'){
          gmPicks={}; gmPicks[vid2]=1;
          gmEl.querySelectorAll('[data-gm-sub]').forEach(function(s){ s.setAttribute('aria-checked',s===sub?'true':'false'); });
        } else if(gmOpt.type==='multi_pick'&&!gmOpt.dup){
          if(gmPicks[vid2]){ delete gmPicks[vid2]; sub.setAttribute('aria-checked','false'); }
          else if(gmPickCount()<(gmOpt.qty|0)){ gmPicks[vid2]=1; sub.setAttribute('aria-checked','true'); }
        }
        gmSyncUi();
        return;
      }
      if(optBtn){
        var o=gmFind(t,optBtn.getAttribute('data-gm-opt')); if(!o) return;
        if(gmOpt!==o){ gmOpt=o; gmPicks={};
          if(o.type==='single') gmPicks[o.items[0].vid]=1;
          gmEl.querySelectorAll('[data-gm-opt]').forEach(function(c){
            var on=c===optBtn;
            c.setAttribute('aria-checked',on?'true':'false');
            c.classList.toggle('is-open',on&&(o.type==='flavour_pick'||o.type==='multi_pick'));
          });
          gmEl.querySelectorAll('[data-gm-sub]').forEach(function(s){ s.setAttribute('aria-checked','false'); });
          gmEl.querySelectorAll('[data-gm-n]').forEach(function(n){ n.textContent='0'; });
        }
        gmSyncUi();
        return;
      }
      if(e.target.closest('#nzsCdrGmOk')) gmConfirm();
    });
    gmEl.addEventListener('keydown',function(e){
      if(e.key==='Escape'){ e.stopPropagation(); gmClose(); return; }
      if((e.key==='Enter'||e.key===' ')&&e.target.closest&&e.target.closest('[data-gm-opt],[data-gm-sub]')){ e.preventDefault(); e.target.closest('[data-gm-opt],[data-gm-sub]').click(); return; }
      if(e.key!=='Tab') return;
      var f=[].slice.call(gmEl.querySelectorAll('button:not([disabled]):not([tabindex="-1"]), [role="radio"][tabindex="0"]'));
      if(!f.length) return;
      var first=f[0], last=f[f.length-1];
      if(e.shiftKey && (document.activeElement===first||document.activeElement===gmEl.querySelector('.nzs-cdr-gm__box'))){ e.preventDefault(); last.focus(); }
      else if(!e.shiftKey && document.activeElement===last){ e.preventDefault(); first.focus(); }
    });
  }
  /* --- per-render sync: Offers repaint + newly-crossed tier detection --- */
  var _tierSeen={};
  try{ _tierSeen=JSON.parse(sessionStorage.getItem('nzsTierSeen')||'{}')||{}; }catch(_e){ _tierSeen={}; }
  function offersAfterRender(cart){
    if(offersPane&&!offersPane.hidden) renderOffers();
    jmFetch(cart);
    if(!gmEl||!drawer.classList.contains('is-open')) return;
    var sub=giftQual(cart); /* NZS-CDR-QUAL-0923: only gift tiers are handled below */
    var toPrompt=[], changed=false;
    REWARDS.forEach(function(t){
      if(!t.opts||!t.opts.length) return;
      var reached=sub>=t.amt;
      if(!reached){ if(_tierSeen[t.amt]){ delete _tierSeen[t.amt]; changed=true; } return; }
      if(tierLines(cart,t).length){ if(!_tierSeen[t.amt]){ _tierSeen[t.amt]=1; changed=true; } return; }
      if(!_tierSeen[t.amt]){
        _tierSeen[t.amt]=1; changed=true;
        if(t.opts.filter(function(o){ return optAvail(o).length; }).length){ toPrompt.push(t); croEv('gift_tier_unlocked',{amt:t.amt}); }
      }
    });
    if(changed){ try{ sessionStorage.setItem('nzsTierSeen',JSON.stringify(_tierSeen)); }catch(_e){} }
    if(toPrompt.length&&gmEl.hidden&&!gmBusyFlag) gmOpen(toPrompt,false);
  }
  /* --- Judge.me review stars: ~1KB aggregate per product, 24h sessionStorage cache, drawer-open
     only, uncached products only. No metafield values exist on this shop (REVAMP backend), and
     the widget API has no batch mode — this is the lightest compliant retrieval. --- */
  var _jm={};
  try{ _jm=JSON.parse(sessionStorage.getItem('nzsJmAgg')||'{}')||{}; }catch(_e){ _jm={}; }
  var JM_TTL=86400000;
  var STAR_ONE='<svg viewBox="0 0 16 16" width="13" height="13"><path fill="currentColor" d="M8 1.4l2 4.1 4.5.6-3.3 3.1.8 4.5L8 11.6l-4 2.1.8-4.5L1.5 6.1 6 5.5z"/></svg>';
  var STARS5=STAR_ONE+STAR_ONE+STAR_ONE+STAR_ONE+STAR_ONE;
  function jmEntry(pid){ var e=_jm[pid]; return (e&&(Date.now()-e.t)<JM_TTL)?e:null; }
  function jmHtml(e){
    if(!e||!(e.n>0)||!(e.a>0)) return '';
    var pctW=Math.max(0,Math.min(100,e.a/5*100));
    return '<div class="nzs-cdr__stars" role="img" aria-label="Rated '+e.a.toFixed(1)+' out of 5 from '+e.n+' review'+(e.n===1?'':'s')+'">'
      +'<span class="nzs-cdr__stars-row" aria-hidden="true" style="color:#d8dde3">'+STARS5
      +'<span class="nzs-cdr__stars-fill" style="width:'+pctW+'%;color:#f5a623">'+STARS5+'</span></span>'
      +'<span class="nzs-cdr__stars-txt" aria-hidden="true">'+e.a.toFixed(1)+' ('+e.n+')</span></div>';
  }
  /* NZS-CDR-NOSHIFT-0922: zero reviews retain a 20px slot; grey stars have no invented rating. */
  function jmRowFor(it){ return '<div class="nzs-cdr__stars-slot">'+(jmHtml(jmEntry(it.product_id))||'<span class="nzs-cdr__stars-row" aria-hidden="true">'+STARS5+'</span>')+'</div>'; }
  var _jmSaveT=null;
  function jmSave(){ clearTimeout(_jmSaveT); _jmSaveT=setTimeout(function(){ try{ sessionStorage.setItem('nzsJmAgg',JSON.stringify(_jm)); }catch(_e){} },400); }
  /* NZS-CDR-CAB-0823: cache-or-fetch a product's review aggregate ONCE. Shared primitive so both the
     cart rows (jmFetch) and the Customers-Also-Bought cards (loadRecs) use one definition — no N+1,
     zeros cached too. Resolves the entry (or null if the shop domain is unavailable). */
  var _jmP={}; /* NZS-SPD-0927-B4: one in-flight request per product while the first is pending */
  function jmGet(pid){
    var e=jmEntry(pid); if(e) return Promise.resolve(e);
    if(_jmP[pid]) return _jmP[pid];
    var sd=(window.Shopify&&Shopify.shop)||''; if(!sd) return Promise.resolve(null);
    return _jmP[pid]=fetch('https://cdn.judge.me/reviews/reviews_for_widget?url='+sd+'&shop_domain='+sd+'&platform=shopify&per_page=0&page=1&product_id='+pid)
      .then(function(r){ if(!r.ok) throw 0; return r.json(); })
      .then(function(j){ _jm[pid]={a:parseFloat(j.average_rating)||0,n:j.number_of_reviews|0,t:Date.now()}; jmSave(); return _jm[pid]; })
      .catch(function(){ _jm[pid]={a:0,n:0,t:Date.now()}; jmSave(); return _jm[pid]; })
      .then(function(x){ delete _jmP[pid]; return x; });
  }
  window.nzsJmStars=function(pid){ return jmGet(pid).then(jmHtml); }; /* NZS-PDP-TIDY-0924: PDP Complete the Stack reuses the drawer's review cache */
  function jmFetch(cart){
    if(!drawer.classList.contains('is-open')) return;
    var seen={};
    ((cart&&cart.items)||[]).forEach(function(it){
      var pid=it.product_id; if(!pid||seen[pid]||jmEntry(pid)) return;
      if((it.properties||{})._nzs_gift) return;
      seen[pid]=1;
      jmGet(pid).then(function(){
        /* NZS-CDR-NOSHIFT-0922: fill every matching variant's existing slot. */
        itemsEl.querySelectorAll('.nzs-cdr__item[data-pid="'+pid+'"]').forEach(function(row){
          var slot=row.querySelector('.nzs-cdr__stars-slot'); if(slot) slot.innerHTML=jmRowFor(it).replace(/^<div[^>]*>|<\/div>$/g,'');
        });
      });
    });
  }
  /* --- Recently-Viewed product click: skeleton now (it closes the drawer instantly), navigate.
     NZS-SKCLOSE-0903: was close() + 330ms wait = the drawer visibly sliding off before every nav. --- */
  if(rvBox) rvBox.addEventListener('click',function(e){
    var a=e.target.closest('a[href*="/products/"]');
    if(!a||e.defaultPrevented||e.button!==0||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey) return;
    e.preventDefault();
    if(window.__nzsNavSkTo) window.__nzsNavSkTo(a.href); else location.assign(a.href);
  });
  /* NZS-SPD-0927-SM-CLOSED (owner-approved 28 Sep, ported 10 Oct): the CLOSED drawer is inert, so Tab never reaches its
     off-screen controls (the pre-rendered rows, tabs, close, checkout). On #nzsCartDrawer only; removed first thing on open
     (before the slide and nzsOverlay's initialFocus), back when the close slide ends (transitionend on the drawer's own
     transform, or 600 ms fallback) only if still shut. With no close transition (reduced motion, the skeleton's transition
     kill) it lands in a microtask, after close's focus restore. No visual change. */
  var _closedT=0;
  function closedEnd(e){ if(e&&(e.target!==drawer||e.propertyName!=='transform')) return; clearTimeout(_closedT); _closedT=0; drawer.removeEventListener('transitionend',closedEnd); if(!drawer.classList.contains('is-open')) drawer.inert=true; }
  function closedInert(on){ clearTimeout(_closedT); _closedT=0; drawer.removeEventListener('transitionend',closedEnd); if(!on){ drawer.inert=false;
      /* 10 Oct review: nzs-drag-scroll hides rail nav under [inert], and a rail filled while shut (pre-render) never
         re-measures on a transform-only open, so re-measure once it is interactive again (one task later, as D6). */
      setTimeout(function(){ if(window.nzsRefreshRails) window.nzsRefreshRails(document.getElementById('nzsCdrRecs')); },0); return; }
    if((window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches)||document.documentElement.classList.contains('nzs-sk-on')){ Promise.resolve().then(function(){ closedEnd(); }); return; }
    drawer.addEventListener('transitionend',closedEnd); _closedT=setTimeout(closedEnd,600); }
  if(!drawer.classList.contains('is-open')) drawer.inert=true;
  function cartShow(){ closedInert(false); /* NZS-SPD-0927-SM-CLOSED */ selectTab('cart',{focus:false}); drawer.classList.add('is-open'); overlay.classList.add('is-open'); drawer.setAttribute('aria-hidden','false'); overlay.setAttribute('aria-hidden','false'); toggle.setAttribute('aria-expanded','true'); if(window.__nzsX) window.__nzsX.bind(overlay,drawer); /* NZS-XOUT-0928: panel for the resting-box test */ }
  function cartHide(){ drawer.classList.remove('is-open'); overlay.classList.remove('is-open'); drawer.setAttribute('aria-hidden','true'); overlay.setAttribute('aria-hidden','true'); toggle.setAttribute('aria-expanded','false'); if(window.__nzsX) window.__nzsX.unbind(overlay); gmClose(); /* NZS-OFFERS-0820: never leave the gift modal over a closed drawer */ closedInert(true); /* NZS-SPD-0927-SM-CLOSED */ }
  function cartRawClose(){ cartHide(); document.body.style.overflow=''; }
  function cartEnhance(){ if(cartOverlay||!window.nzsOverlay) return; var wasOpen=drawer.classList.contains('is-open'); if(closeBtn) closeBtn.setAttribute('data-nzs-autofocus',''); cartOverlay=window.nzsOverlay.enhance({root:drawer,trigger:toggle,key:'cart',label:'Cart',onOpen:cartShow,onClose:cartHide}); if(wasOpen){ cartRawClose(); cartOverlay.open(); } }
  /* NZS-CDR-SPEED-0922: consume the confirmed add cart without a second read on open. */
  function open(addedCart){ /* NZS-CDR-NOSHIFT-0922 / NZS-CDR-PROMO-DISCLOSE-0922 */
    if(!drawer.classList.contains('is-open')){ _nudgeSeen={}; _nudgeAdded={}; nudgeHarvest(); nudgeOpenSync(addedCart); cdrEnter(); /* NZS-CDR-PRELOAD-1009 */ } /* NZS-CDR-NUDGE-0923: harvest, then land the row for the known cart while still shut; per-open analytics + added set */
    /* NZS-CDR-NOSHIFT-0922 R2: release only before a new open, using known current-cart savings. */
    var openingCart=addedCart&&addedCart.items?addedCart:_lastCart;
    if(openingCart){ useLines(openingCart); if(!drawer.classList.contains('is-open')&&openingCart.items.every(linesKnown)){ if(openingCart===_lastCart&&_patchEnrichment) _patchEnrichment(); _savingsHeld=false; if(openingCart===_lastCart&&_serverSavings===0) savingsPaint(0,false); } }
    codeDisclosure(false); _patchEnrichment=null; _openLines=beginLines(openingCart);
    _cartRetryN=0; if(!cartOverlay&&window.nzsOverlay) cartEnhance(); if(cartOverlay){ cartOverlay.open(); } else { if(window.__nzsCloseAllExcept) window.__nzsCloseAllExcept('cart'); cartShow(); document.body.style.overflow='hidden'; window.__nzsSurfaces=window.__nzsSurfaces||{}; window.__nzsSurfaces.cart=cartRawClose; } if(!_cartReady){ itemsEl.innerHTML='<div class="nzs-cdr__empty">Loading\u2026</div>'; } if(addedCart&&addedCart.items&&addedCart.token){ ++_cartSeq; paintOpenCart(addedCart,_cartSeq); /* NZS-CDR-NOSHIFT-0922 */ } else fetchCart(); }
  function close(){ if(!cartOverlay&&window.nzsOverlay) cartEnhance(); if(cartOverlay) cartOverlay.close(); else cartRawClose(); }
  /* NZS-CDR-SPEED-0922: own the post-add read here so every response shares _cartSeq. */
  document.addEventListener('nzs:cdr-added-cart',function(e){
    var c=e.detail&&e.detail.cart, wantsOpen=e.detail&&e.detail.open;
    function openAfterAdd(fresh){
      open(fresh);
      /* NZS-CDR-SPEED-0922: preserve the existing event only when this handler opens the drawer. */
      if(drawer.classList.contains('is-open')) document.dispatchEvent(new CustomEvent('nzs:cro',{detail:{ev:'cart_drawer_opened_after_add'}}));
    }
    function accept(fresh){
      if(wantsOpen&&!drawer.classList.contains('is-open')) openAfterAdd(fresh);
      else { ++_cartSeq; _cartReady=true; render(fresh); }
    }
    // Reconcile after an active change/apply, never paint over its unverified intermediate cart.
    /* NZS-CDR-SPEED-0922: other adds still wait, even while this gift add is awaiting its turn. */
    var ownGift=_giftAddInLink&&e.detail.cdrLink===_giftAddInLink&&c&&c.items&&c.token;
    if(_chainInFlight&&!ownGift) queueCart(function(){ return codeRead().then(accept).catch(function(){ return fetchCart(); }); });
    else if(c&&c.items&&c.token) accept(c);
    else if(wantsOpen&&!drawer.classList.contains('is-open')) openAfterAdd();
    else fetchCart();
  });
  toggle.addEventListener('click', function(e){ if(e && e.isTrusted && drawer.classList.contains('is-open')) close(); else open(); });
  /* NZS-CDR-CLEAR: single click empties the cart (no confirm, by request). Refresh reuses the
     data-act="remove" path exactly — bump _cartSeq to invalidate in-flight /cart.js, then
     render(cart) on a good cart JSON, else fetchCart(). No reload. */
  var clearBtn = document.getElementById('nzsCdrClear');
  if(clearBtn) clearBtn.addEventListener('click',function(){
    /* NZS-SPEED-LDR-CLEAR: disable and show shared dots until every terminal path. */
    function clearBusyOff(){ if(window.__nzsLoadOff) window.__nzsLoadOff(clearBtn); clearBtn.disabled=false; }
    clearBtn.disabled=true; if(window.__nzsLoadOn) window.__nzsLoadOn(clearBtn);
    var seq=++_cartSeq;
    fetch(cartRoot+'cart/clear.js',{method:'POST',headers:{'Content-Type':'application/json'}})
      .then(function(r){ if(!r.ok) throw 0; return r.json(); })
      .then(function(cart){ if(seq!==_cartSeq){ clearBusyOff(); return; } if(cart && cart.items && cart.token){ render(cart); } else { fetchCart(); } clearBusyOff(); })
      .catch(function(){ clearBusyOff(); fetchCart(); });
  });
  if(closeBtn) closeBtn.addEventListener('click',close);
  if(overlay) overlay.addEventListener('click',close);
  document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&!cartOverlay&&drawer.classList.contains('is-open')) cartRawClose(); });
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',cartEnhance,{once:true}); else cartEnhance();
  /* recommended-for-you one-click add (delegated) */
  var recsRowEl=document.getElementById('nzsCdrRecsRow');
  /* NZS-CDR-RECS-WHEEL (Blake 2026-07-31): a mouse wheel over the strip swipes it
     horizontally instead of fighting the drawer's vertical scroll. */
  /* NZS-RAILS-0921: the shared rail engine keeps wheel scrolling vertical. */
  if(recsRowEl) recsRowEl.addEventListener('click',function(e){
    var btn=e.target.closest('[data-rec-add]'); if(!btn||btn.disabled) return;
    /* NZS-SPEED-LDR-RECS: one label element, one shared loadOn/loadOff state. */
    /* NZS-UPSELL-0911: ponytail: edit the existing hook instead of a second implementation. */
    var card=btn.closest('.nzs-cdr__rec'); if(!card) return;
    var pid=card.getAttribute('data-rec-pid'), price=Number(card.getAttribute('data-rec-price')), vid=parseInt(btn.dataset.recAdd,10), pos=Array.prototype.indexOf.call(recsRowEl.children,card);
    var label=btn.querySelector('.nzs-speed-label');
    btn.classList.remove('is-err'); /* NZS-LOADER-0923-L10 */
    btn.disabled=true; if(window.__nzsLoadOn) window.__nzsLoadOn(btn);
    var recLink=card.querySelector('a[href*="/products/"]'); /* NZS-UPSELL-0911: ponytail: edit the existing hook instead of a second implementation. */
    var recMatch=((recLink&&recLink.getAttribute('href'))||'').split('?')[0].match(/\/products\/([^\/?#]+)/);
    var recAdd=window.nzsATC
      ? window.nzsATC.add({items:[{id:parseInt(btn.dataset.recAdd,10),quantity:1}]},{handle:recMatch?recMatch[1]:''})
      : Promise.reject(new Error('Please try again'));
    recAdd.then(function(){ croEv('rec_add',{surface:'cdr',pid:pid,vid:vid,price:price,pos:pos}); if(window.__nzsLoadOff) window.__nzsLoadOff(btn); btn.disabled=false; recsKey=''; /* NZS-CDR-SPEED-0922: confirmed-add hook supplies the cart once. */ }).catch(function(err){ var message=err.message||"Couldn't add to cart"; if(window.__nzsLoadOff) window.__nzsLoadOff(btn); if(label) label.textContent=message; btn.title=message; btn.classList.add('is-err'); /* NZS-LOADER-0923-L10: make the message readable */ setTimeout(function(){ if(!btn.isConnected) return; if(label) label.textContent='Add'; btn.removeAttribute('title'); btn.classList.remove('is-err'); btn.disabled=false; },2500); }); /* NZS-UPSELL-0911: ponytail: edit the existing hook instead of a second implementation. */
  });
  /* mobile nav drawer */
  var mBtn = document.getElementById('nzsBurger');
  var mNav = document.getElementById('nzsMnav');
  var mOv = document.getElementById('nzsMnavOverlay');
  var mCl = document.getElementById('nzsMnavClose');
  var moreWrap = document.getElementById('nzsMore');
  var mOverlay = null;
  function isDesktop(){ return window.matchMedia('(min-width:1101px)').matches; }
  function moreSet(o){ if(!moreWrap) return; if(o && window.__nzsCloseAllExcept) window.__nzsCloseAllExcept('more'); moreWrap.classList.toggle('is-open', o); mBtn.classList.toggle('is-active', o); mBtn.setAttribute('aria-expanded', o?'true':'false'); var pn=moreWrap.querySelector('.nzs-more__panel'); if(pn) pn.setAttribute('aria-hidden', o?'false':'true'); }
  function mShow(){ mNav.classList.add('is-open'); mOv.classList.add('is-open'); mNav.setAttribute('aria-hidden','false'); mBtn.setAttribute('aria-expanded','true'); mBtn.classList.add('is-active'); }
  function mHide(){ mNav.classList.remove('is-open'); mOv.classList.remove('is-open'); mNav.setAttribute('aria-hidden','true'); mBtn.setAttribute('aria-expanded','false'); mBtn.classList.remove('is-active'); }
  function mRawClose(){ mHide(); document.body.style.overflow=''; }
  function mEnhance(){ if(mOverlay||!window.nzsOverlay) return; var wasOpen=mNav.classList.contains('is-open'); mOverlay=window.nzsOverlay.enhance({root:mNav,trigger:mBtn,key:'mnav',label:'Menu',onOpen:mShow,onClose:mHide}); if(wasOpen){ mRawClose(); mOverlay.open(); } }
  function mOpen(){ if(!mOverlay&&window.nzsOverlay) mEnhance(); if(mOverlay){ mOverlay.open(); return; } if(window.__nzsCloseAllExcept) window.__nzsCloseAllExcept('mnav'); mShow(); document.body.style.overflow='hidden'; window.__nzsSurfaces=window.__nzsSurfaces||{}; window.__nzsSurfaces.mnav=mRawClose; }
  function mClose(){ if(!mOverlay&&window.nzsOverlay) mEnhance(); if(mOverlay) mOverlay.close(); else mRawClose(); }
  if(mBtn&&mNav){
    mBtn.addEventListener('click',function(e){ e.stopPropagation(); if(isDesktop() && moreWrap){ moreSet(!moreWrap.classList.contains('is-open')); } else { mOpen(); } });
    if(mCl) mCl.addEventListener('click',mClose);
    if(mOv) mOv.addEventListener('click',mClose);
    document.addEventListener('keydown',function(e){ if(e.key==='Escape'){ if(!mOverlay&&mNav.classList.contains('is-open')) mClose(); moreSet(false); } });
    if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',mEnhance,{once:true}); else mEnhance();
  }
  if(moreWrap){
    var mSub=moreWrap.querySelector('[data-more-sub]');
    if(mSub){ var msb=mSub.querySelector('.nzs-more__subbtn'), msp=mSub.querySelector('.nzs-more__subpanel');
      if(msb) msb.addEventListener('click',function(e){ e.stopPropagation(); var o=!mSub.classList.contains('is-open'); mSub.classList.toggle('is-open',o); msb.setAttribute('aria-expanded',o?'true':'false'); if(msp) msp.style.height=o?(msp.scrollHeight+'px'):'0px'; }); }
    var mPanel=moreWrap.querySelector('.nzs-more__panel'); if(mPanel) mPanel.addEventListener('click',function(e){ e.stopPropagation(); });
    document.addEventListener('click',function(){ moreSet(false); });
  }
  /* NZS-MNAV-PANELS: slide-across panels (replaced the Brand/Category accordions) */
  if(mNav){
    var mPanes={}; mNav.querySelectorAll('[data-mpane]').forEach(function(p){ mPanes[p.getAttribute('data-mpane')]=p; });
    var mStack=[];
    function mSet(stack){
      mStack=stack;
      mNav.classList.toggle('has-sub', stack.length>0);
      Object.keys(mPanes).forEach(function(k){
        var i=stack.indexOf(k);
        mPanes[k].classList.toggle('is-on', i>-1 && i===stack.length-1);
        mPanes[k].classList.toggle('is-under', i>-1 && i<stack.length-1);
      });
    }
    mNav.addEventListener('click', function(e){
      var o=e.target.closest('[data-mopen]');
      if(o){ e.preventDefault(); mSet(mStack.concat(o.getAttribute('data-mopen'))); return; }
      if(e.target.closest('[data-mback]')){ mSet(mStack.slice(0,-1)); return; }
      if(e.target.closest('[data-mclose]')){ if(mCl) mCl.click(); }
    });
    /* reset to root after the drawer finishes sliding shut */
    mNav.addEventListener('transitionend', function(e){ if(e.target===mNav && !mNav.classList.contains('is-open') && mStack.length) mSet([]); });
    /* r2: reduced-motion kills the drawer transition (no transitionend) — reset on reopen too */
    if(mBtn) mBtn.addEventListener('click', function(){ if(mStack.length) mSet([]); });
    /* NZS-MNAV-SHEET: bottom-sheet drag — pull the handle/header down >90px to close */
    var dragY=null, dragDY=0;
    mNav.addEventListener('touchstart', function(e){
      if(e.target.closest('button,a')) return;
      var inHead=e.target.closest('.nzs-mnav__head,.nzs-mnav__phead');
      if(!inHead && e.touches[0].clientY - mNav.getBoundingClientRect().top > 110) return; /* NZS-MNAV-SHEET r2 (Blake): 30px grab band was too small -- top 110px now drags (links/buttons still bail above) */
      dragY=e.touches[0].clientY; dragDY=0; mNav.classList.add('is-dragging');
    }, {passive:true});
    var dragRaf=0; /* NZS-MNAV-SMOOTH-0903: coalesce touchmove writes to one per frame */
    mNav.addEventListener('touchmove', function(e){
      if(dragY===null) return;
      dragDY=Math.max(0, e.touches[0].clientY-dragY);
      if(!dragRaf) dragRaf=requestAnimationFrame(function(){ dragRaf=0; if(dragY!==null) mNav.style.transform='translateY('+dragDY+'px)'; });
    }, {passive:true});
    mNav.addEventListener('touchend', function(){
      if(dragY===null) return;
      mNav.classList.remove('is-dragging'); mNav.style.transform='';
      if(dragDY>90) mClose();
      dragY=null; dragDY=0;
    });
  }
  /* NZS-ONEOPEN: register this IIFE's surfaces with the shared registry (created in the mega-menu
     IIFE above; re-guarded here in case that block ever fails to run). Closers only strip state. */
  window.__nzsSurfaces = window.__nzsSurfaces || {};
  if(!cartOverlay) window.__nzsSurfaces.cart = cartRawClose; /* replaced by nzsOverlay.enhance at init */
  window.__nzsSurfaces.more = function(){ moreSet(false); };
  if(mBtn&&mNav&&!mOverlay) window.__nzsSurfaces.mnav = mRawClose; /* replaced by nzsOverlay.enhance at init */
  /* NZS-SPD-0820 item 4: the badge count renders server-side ({{ cart.item_count }} in
     nzs-header.liquid), so the load-time /cart.js is only a re-sync - skip it entirely
     unless a cart cookie exists (anonymous first visits now make zero cart requests). */
  if(/(?:^|; )cart=/.test(document.cookie)) fetch(cartRoot+'cart.js').then(function(r){ if(!r.ok) throw 0; return r.json();}).then(function(c){ setBadge(c.item_count); nudgePrefetchCart(c); /* NZS-CDR-NUDGE-0923: reuse this read for the idle prefetch decision */ cdrPreRender(c); /* NZS-CDR-PRELOAD-1009 */ }).catch(function(){});
  window.addEventListener('pageshow', function(e){ if(e.persisted) fetchCart(); });
})();
